var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-503-error-service-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}svg#freepik_stories-503-error-service-unavailable:not(.animated) .animable{opacity:0}svg#freepik_stories-503-error-service-unavailable.animated #freepik--speech-bubble--inject-2{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp,1.5s Infinite linear wind;animation-delay:0s,1s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 334.87px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 250,
    cy: 334.87,
    rx: 238.81,
    ry: 131.05,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 334.87px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "248.803px 317.757px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M31.61 349.49c15.14 13.42 51.1 29 72.46 39.39a9.39 9.39 0 0 0 6 .44c29.9-9.48 54.08-23.46 73.81-40.9a2.46 2.46 0 0 0-.24-4c-20.91-14.72-59.64-26.63-87.78-31.73a16.22 16.22 0 0 0-6.32.34q-37.86 11.12-58.13 32a3.09 3.09 0 0 0 .2 4.46Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "107.675px 351.072px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M203.9 403.53c20.71-12.88 20.71-33.77 0-46.65s-54.29-12.88-75 0-20.71 33.77 0 46.65 54.29 12.88 75 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "166.4px 380.205px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.22 400.43 105-60.69c1.75-1 1.75-2.65 0-3.66l-195-113a7 7 0 0 0-6.33 0l-105 60.69c-1.75 1-1.75 2.65 0 3.66l195 113a7 7 0 0 0 6.33 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "304.055px 311.755px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.27 388.54c11.71-7.29 11.71-19.09 0-26.38s-30.69-7.28-42.4 0-11.71 19.09 0 26.38 30.69 7.28 42.4 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "437.07px 375.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "303.34px 220.68px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,1.5s Infinite linear wind",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-2",
    className: "animable",
    style: {
      transformOrigin: "303.34px 220.68px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2",
    className: "animable",
    style: {
      transformOrigin: "303.34px 255.285px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "212.105px 176.05px"
    },
    id: "elc8yrhcjhkya",
    className: "animable",
    d: "M259.14 154.86v-32.45l-3.31-1.85v32.46l-90.76 52.48v3.83l90.76-52.55v72.91l3.31 1.85v-76.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      transformOrigin: "212.105px 176.05px"
    },
    className: "animable",
    d: "M259.14 154.86v-32.45l-3.31-1.85v32.46l-90.76 52.48v3.83l90.76-52.55v72.91l3.31 1.85v-76.68z",
    id: "elfe6oagj7ad7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.76 175v112.92l3.32-2V213l94.06-54.47v73l3.32-1.85V116.8Zm97.38-20.17-94.06 54.47v-25.52l94.06-54.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "212.11px 202.36px"
    },
    id: "elxzr9rdggdzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.76 175v112.92l3.32-2V213l94.06-54.47v73l3.32-1.85V116.8Zm97.38-20.17-94.06 54.47v-25.52l94.06-54.17Z",
    style: {
      opacity: 0.2,
      transformOrigin: "212.11px 202.36px"
    },
    className: "animable",
    id: "eln1jtmkl4e7b"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "397.885px 283.535px"
    },
    id: "elb36iilib7dl",
    className: "animable",
    d: "M444.92 262.35v-32.46l-3.32-1.84v32.46l-90.75 52.48v3.83l90.75-52.55v72.91l3.32 1.84v-76.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      transformOrigin: "397.885px 283.535px"
    },
    className: "animable",
    d: "M444.92 262.35v-32.46l-3.32-1.84v32.46l-90.75 52.48v3.83l90.75-52.55v72.91l3.32 1.84v-76.67z",
    id: "el20ew85xxtq5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.99px 284.395px"
    },
    id: "el92jvbw3pore",
    className: "animable",
    d: "M161.76 175.3v-.27l-.24.13-3.07-1.78v112.63l3.31 1.91V186.69l182.46 105.03V393.5l3.31 1.91V282.5L161.76 175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "252.99px 284.395px"
    },
    className: "animable",
    d: "M161.76 175.3v-.27l-.24.13-3.07-1.78v112.63l3.31 1.91V186.69l182.46 105.03V393.5l3.31 1.91V282.5L161.76 175.3z",
    id: "ellhwt0jvlcpg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.53 282.52v112.89l3.32-2v-72.9l94.07-54.46v73l3.31-1.84V224.29Zm3.32 34.29v-25.54l94.07-54.18v25.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "397.88px 309.85px"
    },
    id: "elw7kk0xeq2nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.53 282.52v112.89l3.32-2v-72.9l94.07-54.46v73l3.31-1.84V224.29Zm3.32 34.29v-25.54l94.07-54.18v25.26Z",
    style: {
      opacity: 0.2,
      transformOrigin: "397.88px 309.85px"
    },
    className: "animable",
    id: "eldyewtf6uljp"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "303.34px 198.84px"
    },
    id: "el38gwk65viip",
    className: "animable",
    d: "m347.53 282.52 100.7-58.23-189.09-109.13-100.69 58.22 189.08 109.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "303.34px 198.84px"
    },
    className: "animable",
    d: "m347.53 282.52 100.7-58.23-189.09-109.13-100.69 58.22 189.08 109.14z",
    id: "el488m7rcuhg3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Phone--inject-2",
    className: "animable",
    style: {
      transformOrigin: "235.336px 163.469px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "236.078px 169.055px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.15 164.44 39.22-22.37a3.34 3.34 0 0 1 3 0l39.5 22.8a.92.92 0 0 1 0 1.73l-39.07 22.6a3.29 3.29 0 0 1-3 0l-39.68-23a.91.91 0 0 1 .03-1.76Z",
    style: {
      opacity: 0.2,
      transformOrigin: "246.966px 165.638px"
    },
    className: "animable",
    id: "elnzmgb73batj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185 179.15 28.54 16.48a7.05 7.05 0 0 0 6.39 0l7.45-4.32c1.76-1 1.76-2.67 0-3.69l-28.55-16.48a7 7 0 0 0-6.38 0l-7.45 4.32c-1.76 1.02-1.76 2.67 0 3.69Z",
    style: {
      opacity: 0.2,
      transformOrigin: "206.19px 183.383px"
    },
    className: "animable",
    id: "elxfar5ynmwn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cable--inject-2",
    className: "animable",
    style: {
      transformOrigin: "212.176px 148.012px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.09 136.44c-.26-1.51-1.33-2.24-2.65-2.83-.12-.06-.27-.05-.36-.1s-.09-.12-.15-.18a6 6 0 0 0-3.41-1.57h-.84a7.6 7.6 0 0 0-4.45-1.21 4.38 4.38 0 0 0-1.76.55 1.88 1.88 0 0 0-.24-.14 4.33 4.33 0 0 0-4.38.4 3 3 0 0 0-.71-.26 4.07 4.07 0 0 0-2 .28 6.31 6.31 0 0 0-1.74 1 5.59 5.59 0 0 0-.83 1 2.26 2.26 0 0 0-.45 0 4.71 4.71 0 0 0-3.08 2c-.08.1-.12.21-.2.31a4.35 4.35 0 0 0-2.83 1 4.65 4.65 0 0 0-1.39 2.4 4.57 4.57 0 0 0-2.38 3.13 5 5 0 0 0 .13 2 4.48 4.48 0 0 0-2 2.7 2.61 2.61 0 0 0 .21 1.56 6.51 6.51 0 0 0-1.15.79 3.61 3.61 0 0 0-.7 1 5.64 5.64 0 0 0-1.41.25 4 4 0 0 0-.59.28 5.06 5.06 0 0 0-3.84 0c-.19.06-.33.16-.5.23a5.19 5.19 0 0 0-3.68-.08 5.59 5.59 0 0 0-3.29-.74 5.17 5.17 0 0 0-1.85.68 4.62 4.62 0 0 0-2.27-.2 4.81 4.81 0 0 0-2.83 2.19 4.12 4.12 0 0 0-.23.58 3.21 3.21 0 0 0-1.13.72 3.92 3.92 0 0 0-.9 2.19 4.15 4.15 0 0 0 0 .7 3.5 3.5 0 0 0 .43 1.51 3.39 3.39 0 0 0 .74 3.77 3.77 3.77 0 0 0 .82.57 1.79 1.79 0 0 0 0 .24 2.4 2.4 0 0 0 .92 1.76 2.88 2.88 0 0 0 2.6.42c.31-.09 0-.44-.2-.47a9.23 9.23 0 0 1-.94-.14 2.4 2.4 0 0 1-.76-.4 1.67 1.67 0 0 1-.59-1 6.79 6.79 0 0 0 1.3.19 2.87 2.87 0 0 0 2.31-.67.91.91 0 0 0 0-1.22 1.91 1.91 0 0 0-1.47-.62 3.42 3.42 0 0 0-2.92 1.21 1.86 1.86 0 0 1-.19-.11 2.63 2.63 0 0 1-1-2.64.15.15 0 0 1 0-.07 3.87 3.87 0 0 0 3.07 1 1.17 1.17 0 0 0 1.09-1.22 1.75 1.75 0 0 0-1.12-1.46 3.37 3.37 0 0 0-2.32-.13 4.37 4.37 0 0 0-.78.39 2.15 2.15 0 0 1-.17-.79 5.15 5.15 0 0 1 .09-1.11 1.09 1.09 0 0 1 .07-.3 3 3 0 0 1 1-1.4 2.84 2.84 0 0 0 1.08 1.85A2 2 0 0 0 188 156a1.38 1.38 0 0 0-.15-1.61 3 3 0 0 0-1.58-1 4.47 4.47 0 0 0-1.09-.15 4.16 4.16 0 0 1 1.6-1.65 3.41 3.41 0 0 1 2.11-.25 4.25 4.25 0 0 0-.88 1.36 1.75 1.75 0 0 0 .21 1.68 1.55 1.55 0 0 0 1.69.53 1.94 1.94 0 0 0 1.22-1.3 2 2 0 0 0-.25-1.76 2.72 2.72 0 0 0-.61-.61 3.78 3.78 0 0 1 .88-.36 4.37 4.37 0 0 1 2.8.38c-.89.7-1.88 1.52-1.69 2.75s1.54 1.38 2.53.79a2.24 2.24 0 0 0 1-1.58 2.32 2.32 0 0 0-.51-1.78 4.37 4.37 0 0 1 2.43 0 5 5 0 0 0-.71.67 2.39 2.39 0 0 0-.66 1.83 1.53 1.53 0 0 0 1.33 1.25 1.63 1.63 0 0 0 1.63-.69 2.37 2.37 0 0 0-.27-3 5.59 5.59 0 0 1 .61-.26 4 4 0 0 1 2.49 0 3 3 0 0 0-.79 1.74 2.16 2.16 0 0 0 .59 1.69 1.13 1.13 0 0 0 1.47.23c1.3-1 .83-2.26.07-3.45a.81.81 0 0 0-.12-.14 3.74 3.74 0 0 1 .91-.3h.3a2.59 2.59 0 0 0 .4 1.39 2.83 2.83 0 0 0 1.54 1.15 1.27 1.27 0 0 0 1.6-.53c.58-1.11-.48-1.79-1.34-2.26a5.36 5.36 0 0 0-1.14-.4 3.69 3.69 0 0 1 1.11-1.08l.28-.15a5.54 5.54 0 0 0 1.49 1 3.49 3.49 0 0 0 2.4.18c.56-.17 1.05-.58.82-1.2-.46-1.24-1.68-1.32-2.86-1.26a7.55 7.55 0 0 0-1.49.29 2.49 2.49 0 0 1 .25-2.2 4.07 4.07 0 0 1 1-1 5.26 5.26 0 0 0 .6.88 3.22 3.22 0 0 0 3.31 1.06 1.25 1.25 0 0 0 1-1.23 1.57 1.57 0 0 0-.91-1.4 5.17 5.17 0 0 0-3.49-.36 4.36 4.36 0 0 1 .2-2.5 4 4 0 0 1 1.06-1.37.78.78 0 0 1 .15-.1v.36c.42 1.44 1.1 2.43 2.73 2.41a1.53 1.53 0 0 0 1.34-1 1.59 1.59 0 0 0-.29-1.78 3.9 3.9 0 0 0-2.82-1 1.16 1.16 0 0 1 0-.18 3.84 3.84 0 0 1 1.86-2.06 3 3 0 0 1 1.1-.22 2.78 2.78 0 0 0 .34 2.56c.67.81 2.19 1.54 2.71.12s-.72-2.56-1.93-3.18a4.1 4.1 0 0 1 1-1.17 2.82 2.82 0 0 1 1.52-.58 4.08 4.08 0 0 0-.23 2.07 2.43 2.43 0 0 0 1 1.61 2 2 0 0 0 2.92-1.41 2.16 2.16 0 0 0-.59-1.59 4.67 4.67 0 0 0-1.86-1.25 5.33 5.33 0 0 1 1.44-1.24 3.08 3.08 0 0 1 2.49-.45 4.76 4.76 0 0 0-.89 1.6 2 2 0 0 0 .49 2 1.31 1.31 0 0 0 1.63.31 1.88 1.88 0 0 0 .9-1.7 3.41 3.41 0 0 0-1-2.28 3.39 3.39 0 0 1 1.29-.6 3.67 3.67 0 0 1 2.16.33c-.15.16-.32.26-.47.44-.66.84-1.26 1.67-.75 2.75a1.74 1.74 0 0 0 1.64.92 1.79 1.79 0 0 0 1.6-1.06c.5-1.19 0-2-.75-3a.18.18 0 0 1 .07 0 4.39 4.39 0 0 1 2.18-.32 6.74 6.74 0 0 1 2.28.63 3.4 3.4 0 0 0-1.81 1.08 2.24 2.24 0 0 0-.5 1.87 1.33 1.33 0 0 0 1.31 1.08 2.59 2.59 0 0 0 2.79-2.32c.1-.43-.1-.7-.2-1.09a9.7 9.7 0 0 1 1.37.26 4.46 4.46 0 0 1 1.4.73 3 3 0 0 0-1.81.8 2 2 0 0 0 .16 2.88 1.67 1.67 0 0 0 2.49-.35 3 3 0 0 0 .53-2.42 3.46 3.46 0 0 1 .6.25 2.87 2.87 0 0 1 1.4 2.31 3.85 3.85 0 0 1-1.11 2.75c-.28.32.11.76.4.49a4 4 0 0 0 1.42-3.84Zm-56.6 25.79a2.72 2.72 0 0 1 1.29-.44 1.83 1.83 0 0 1 1.15.16.22.22 0 0 1 .09.26c0 .11 0 .12-.16.2a1.61 1.61 0 0 1-.63.18 6.25 6.25 0 0 1-.87 0h-.25a4.94 4.94 0 0 1-.67-.12s-.13 0-.12 0a.52.52 0 0 1 .17-.24Zm-.07-3.93a1.16 1.16 0 0 1 1 .66c.15.38-.16.54-.52.53a3.29 3.29 0 0 1-2.15-.87 1.85 1.85 0 0 1 .55-.26 3.08 3.08 0 0 1 1.12-.06Zm1.86-3.31a.6.6 0 0 1-.22.83 1 1 0 0 1-.91 0A2 2 0 0 1 185 154h.1a2.3 2.3 0 0 1 2.18 1Zm3.16-2.34a1.57 1.57 0 0 1-.35 1.25.75.75 0 0 1-1.1.22 1 1 0 0 1-.23-1.11 3.34 3.34 0 0 1 .91-1.37 1.69 1.69 0 0 1 .77 1.01Zm4.12 1.36a1.26 1.26 0 0 1-1.14.49.46.46 0 0 1-.42-.59 2.83 2.83 0 0 1 1.26-2 2.63 2.63 0 0 1 .33-.2 1.67 1.67 0 0 1 .46.94 2 2 0 0 1-.49 1.35Zm4.2-.16a1 1 0 0 1-1.08.61.8.8 0 0 1-.56-1.05 3.17 3.17 0 0 1 1.26-1.61 1.68 1.68 0 0 1 .38 2.05Zm4.68-.19a.75.75 0 0 1-.67.67c-.37 0-.52-.33-.58-.64a2.26 2.26 0 0 1 .09-1.36 2.08 2.08 0 0 1 .47-.67 2.54 2.54 0 0 1 .29.36 2.41 2.41 0 0 1 .4 1.64Zm3.08-2.23c.44.26 1.39.9.56 1.37-.39.22-.89-.12-1.19-.42a1.93 1.93 0 0 1-.53-1.12 2.64 2.64 0 0 1 0-.28 4 4 0 0 1 1.16.45Zm2.92-2.9a2 2 0 0 1 1.22.34c.2.14.41.44.13.64a1.77 1.77 0 0 1-1.57.05 4.7 4.7 0 0 1-1.38-.83 6.74 6.74 0 0 1 1.6-.2Zm.78-4.16a4.89 4.89 0 0 1 1.32.18c.41.12 1 .29 1.09.71.3.84-.65 1.11-1.28 1a3.3 3.3 0 0 1-1.92-1.69 2.69 2.69 0 0 1 .79-.2Zm1.67-4.85c.93.08 2 .4 2.05 1.46a1 1 0 0 1-1.55.76 2.43 2.43 0 0 1-.94-2.19 2.12 2.12 0 0 1 .44-.03Zm4.19-2.56a2.44 2.44 0 0 1 .9 1.39c.06.36 0 .84-.48.73a1.76 1.76 0 0 1-1.31-1.87 2.64 2.64 0 0 1 .14-.69 3.35 3.35 0 0 1 .75.48Zm4.89-1.18a1 1 0 0 1-.21 1.15c-.3.32-.73.62-1.16.35-.95-.63-.93-1.67-.71-2.7a2.46 2.46 0 0 1 .14-.38 3 3 0 0 1 1.97 1.58Zm3.54-1.13c-.1.34-.4.72-.79.5a1.3 1.3 0 0 1-.58-1.42 3.71 3.71 0 0 1 .8-1.47 2.43 2.43 0 0 1 .57 2.39Zm4.73-.7a1.38 1.38 0 0 1-1 1 .88.88 0 0 1-.92-.57 1.17 1.17 0 0 1 .11-1 4.53 4.53 0 0 1 1.16-1.42 2.89 2.89 0 0 1 .38.4 1.77 1.77 0 0 1 .27 1.64Zm5.26 0a2.14 2.14 0 0 1-1.18 1.18c-.32.13-.85.18-1-.2a1.49 1.49 0 0 1 .24-1.4 2.26 2.26 0 0 1 1.07-.86 3.56 3.56 0 0 1 .81-.2 1.71 1.71 0 0 1 .06 1.53Zm3.34 2.71c-.12.05-.26.17-.38.17a.66.66 0 0 1-.32 0c-.26-.15-.44-.26-.5-.56a1.61 1.61 0 0 1 .9-1.88 2.11 2.11 0 0 1 1-.16s0-.26 0 .21.04 1.89-.7 2.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "212.176px 148.012px"
    },
    id: "elro0cljntbma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.5px 161.41px"
    },
    id: "el8fi4gcxu4bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.42Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.5px 161.42px"
    },
    id: "eld9okkg3lf9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.5px 161.42px"
    },
    id: "el6y7xmc4qpf3",
    className: "animable",
    d: "M188.5 161.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.42Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.5px 161.42px"
    },
    id: "el9bb7khxbep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "212.176px 148.012px"
    },
    className: "animable",
    id: "elnsff1axjy0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.09 136.44c-.26-1.51-1.33-2.24-2.65-2.83-.12-.06-.27-.05-.36-.1s-.09-.12-.15-.18a6 6 0 0 0-3.41-1.57h-.84a7.6 7.6 0 0 0-4.45-1.21 4.38 4.38 0 0 0-1.76.55 1.88 1.88 0 0 0-.24-.14 4.33 4.33 0 0 0-4.38.4 3 3 0 0 0-.71-.26 4.07 4.07 0 0 0-2 .28 6.31 6.31 0 0 0-1.74 1 5.59 5.59 0 0 0-.83 1 2.26 2.26 0 0 0-.45 0 4.71 4.71 0 0 0-3.08 2c-.08.1-.12.21-.2.31a4.35 4.35 0 0 0-2.83 1 4.65 4.65 0 0 0-1.39 2.4 4.57 4.57 0 0 0-2.38 3.13 5 5 0 0 0 .13 2 4.48 4.48 0 0 0-2 2.7 2.61 2.61 0 0 0 .21 1.56 6.51 6.51 0 0 0-1.15.79 3.61 3.61 0 0 0-.7 1 5.64 5.64 0 0 0-1.41.25 4 4 0 0 0-.59.28 5.06 5.06 0 0 0-3.84 0c-.19.06-.33.16-.5.23a5.19 5.19 0 0 0-3.68-.08 5.59 5.59 0 0 0-3.29-.74 5.17 5.17 0 0 0-1.85.68 4.62 4.62 0 0 0-2.27-.2 4.81 4.81 0 0 0-2.83 2.19 4.12 4.12 0 0 0-.23.58 3.21 3.21 0 0 0-1.13.72 3.92 3.92 0 0 0-.9 2.19 4.15 4.15 0 0 0 0 .7 3.5 3.5 0 0 0 .43 1.51 3.39 3.39 0 0 0 .74 3.77 3.77 3.77 0 0 0 .82.57 1.79 1.79 0 0 0 0 .24 2.4 2.4 0 0 0 .92 1.76 2.88 2.88 0 0 0 2.6.42c.31-.09 0-.44-.2-.47a9.23 9.23 0 0 1-.94-.14 2.4 2.4 0 0 1-.76-.4 1.67 1.67 0 0 1-.59-1 6.79 6.79 0 0 0 1.3.19 2.87 2.87 0 0 0 2.31-.67.91.91 0 0 0 0-1.22 1.91 1.91 0 0 0-1.47-.62 3.42 3.42 0 0 0-2.92 1.21 1.86 1.86 0 0 1-.19-.11 2.63 2.63 0 0 1-1-2.64.15.15 0 0 1 0-.07 3.87 3.87 0 0 0 3.07 1 1.17 1.17 0 0 0 1.09-1.22 1.75 1.75 0 0 0-1.12-1.46 3.37 3.37 0 0 0-2.32-.13 4.37 4.37 0 0 0-.78.39 2.15 2.15 0 0 1-.17-.79 5.15 5.15 0 0 1 .09-1.11 1.09 1.09 0 0 1 .07-.3 3 3 0 0 1 1-1.4 2.84 2.84 0 0 0 1.08 1.85A2 2 0 0 0 188 156a1.38 1.38 0 0 0-.15-1.61 3 3 0 0 0-1.58-1 4.47 4.47 0 0 0-1.09-.15 4.16 4.16 0 0 1 1.6-1.65 3.41 3.41 0 0 1 2.11-.25 4.25 4.25 0 0 0-.88 1.36 1.75 1.75 0 0 0 .21 1.68 1.55 1.55 0 0 0 1.69.53 1.94 1.94 0 0 0 1.22-1.3 2 2 0 0 0-.25-1.76 2.72 2.72 0 0 0-.61-.61 3.78 3.78 0 0 1 .88-.36 4.37 4.37 0 0 1 2.8.38c-.89.7-1.88 1.52-1.69 2.75s1.54 1.38 2.53.79a2.24 2.24 0 0 0 1-1.58 2.32 2.32 0 0 0-.51-1.78 4.37 4.37 0 0 1 2.43 0 5 5 0 0 0-.71.67 2.39 2.39 0 0 0-.66 1.83 1.53 1.53 0 0 0 1.33 1.25 1.63 1.63 0 0 0 1.63-.69 2.37 2.37 0 0 0-.27-3 5.59 5.59 0 0 1 .61-.26 4 4 0 0 1 2.49 0 3 3 0 0 0-.79 1.74 2.16 2.16 0 0 0 .59 1.69 1.13 1.13 0 0 0 1.47.23c1.3-1 .83-2.26.07-3.45a.81.81 0 0 0-.12-.14 3.74 3.74 0 0 1 .91-.3h.3a2.59 2.59 0 0 0 .4 1.39 2.83 2.83 0 0 0 1.54 1.15 1.27 1.27 0 0 0 1.6-.53c.58-1.11-.48-1.79-1.34-2.26a5.36 5.36 0 0 0-1.14-.4 3.69 3.69 0 0 1 1.11-1.08l.28-.15a5.54 5.54 0 0 0 1.49 1 3.49 3.49 0 0 0 2.4.18c.56-.17 1.05-.58.82-1.2-.46-1.24-1.68-1.32-2.86-1.26a7.55 7.55 0 0 0-1.49.29 2.49 2.49 0 0 1 .25-2.2 4.07 4.07 0 0 1 1-1 5.26 5.26 0 0 0 .6.88 3.22 3.22 0 0 0 3.31 1.06 1.25 1.25 0 0 0 1-1.23 1.57 1.57 0 0 0-.91-1.4 5.17 5.17 0 0 0-3.49-.36 4.36 4.36 0 0 1 .2-2.5 4 4 0 0 1 1.06-1.37.78.78 0 0 1 .15-.1v.36c.42 1.44 1.1 2.43 2.73 2.41a1.53 1.53 0 0 0 1.34-1 1.59 1.59 0 0 0-.29-1.78 3.9 3.9 0 0 0-2.82-1 1.16 1.16 0 0 1 0-.18 3.84 3.84 0 0 1 1.86-2.06 3 3 0 0 1 1.1-.22 2.78 2.78 0 0 0 .34 2.56c.67.81 2.19 1.54 2.71.12s-.72-2.56-1.93-3.18a4.1 4.1 0 0 1 1-1.17 2.82 2.82 0 0 1 1.52-.58 4.08 4.08 0 0 0-.23 2.07 2.43 2.43 0 0 0 1 1.61 2 2 0 0 0 2.92-1.41 2.16 2.16 0 0 0-.59-1.59 4.67 4.67 0 0 0-1.86-1.25 5.33 5.33 0 0 1 1.44-1.24 3.08 3.08 0 0 1 2.49-.45 4.76 4.76 0 0 0-.89 1.6 2 2 0 0 0 .49 2 1.31 1.31 0 0 0 1.63.31 1.88 1.88 0 0 0 .9-1.7 3.41 3.41 0 0 0-1-2.28 3.39 3.39 0 0 1 1.29-.6 3.67 3.67 0 0 1 2.16.33c-.15.16-.32.26-.47.44-.66.84-1.26 1.67-.75 2.75a1.74 1.74 0 0 0 1.64.92 1.79 1.79 0 0 0 1.6-1.06c.5-1.19 0-2-.75-3a.18.18 0 0 1 .07 0 4.39 4.39 0 0 1 2.18-.32 6.74 6.74 0 0 1 2.28.63 3.4 3.4 0 0 0-1.81 1.08 2.24 2.24 0 0 0-.5 1.87 1.33 1.33 0 0 0 1.31 1.08 2.59 2.59 0 0 0 2.79-2.32c.1-.43-.1-.7-.2-1.09a9.7 9.7 0 0 1 1.37.26 4.46 4.46 0 0 1 1.4.73 3 3 0 0 0-1.81.8 2 2 0 0 0 .16 2.88 1.67 1.67 0 0 0 2.49-.35 3 3 0 0 0 .53-2.42 3.46 3.46 0 0 1 .6.25 2.87 2.87 0 0 1 1.4 2.31 3.85 3.85 0 0 1-1.11 2.75c-.28.32.11.76.4.49a4 4 0 0 0 1.42-3.84Zm-56.6 25.79a2.72 2.72 0 0 1 1.29-.44 1.83 1.83 0 0 1 1.15.16.22.22 0 0 1 .09.26c0 .11 0 .12-.16.2a1.61 1.61 0 0 1-.63.18 6.25 6.25 0 0 1-.87 0h-.25a4.94 4.94 0 0 1-.67-.12s-.13 0-.12 0a.52.52 0 0 1 .17-.24Zm-.07-3.93a1.16 1.16 0 0 1 1 .66c.15.38-.16.54-.52.53a3.29 3.29 0 0 1-2.15-.87 1.85 1.85 0 0 1 .55-.26 3.08 3.08 0 0 1 1.12-.06Zm1.86-3.31a.6.6 0 0 1-.22.83 1 1 0 0 1-.91 0A2 2 0 0 1 185 154h.1a2.3 2.3 0 0 1 2.18 1Zm3.16-2.34a1.57 1.57 0 0 1-.35 1.25.75.75 0 0 1-1.1.22 1 1 0 0 1-.23-1.11 3.34 3.34 0 0 1 .91-1.37 1.69 1.69 0 0 1 .77 1.01Zm4.12 1.36a1.26 1.26 0 0 1-1.14.49.46.46 0 0 1-.42-.59 2.83 2.83 0 0 1 1.26-2 2.63 2.63 0 0 1 .33-.2 1.67 1.67 0 0 1 .46.94 2 2 0 0 1-.49 1.35Zm4.2-.16a1 1 0 0 1-1.08.61.8.8 0 0 1-.56-1.05 3.17 3.17 0 0 1 1.26-1.61 1.68 1.68 0 0 1 .38 2.05Zm4.68-.19a.75.75 0 0 1-.67.67c-.37 0-.52-.33-.58-.64a2.26 2.26 0 0 1 .09-1.36 2.08 2.08 0 0 1 .47-.67 2.54 2.54 0 0 1 .29.36 2.41 2.41 0 0 1 .4 1.64Zm3.08-2.23c.44.26 1.39.9.56 1.37-.39.22-.89-.12-1.19-.42a1.93 1.93 0 0 1-.53-1.12 2.64 2.64 0 0 1 0-.28 4 4 0 0 1 1.16.45Zm2.92-2.9a2 2 0 0 1 1.22.34c.2.14.41.44.13.64a1.77 1.77 0 0 1-1.57.05 4.7 4.7 0 0 1-1.38-.83 6.74 6.74 0 0 1 1.6-.2Zm.78-4.16a4.89 4.89 0 0 1 1.32.18c.41.12 1 .29 1.09.71.3.84-.65 1.11-1.28 1a3.3 3.3 0 0 1-1.92-1.69 2.69 2.69 0 0 1 .79-.2Zm1.67-4.85c.93.08 2 .4 2.05 1.46a1 1 0 0 1-1.55.76 2.43 2.43 0 0 1-.94-2.19 2.12 2.12 0 0 1 .44-.03Zm4.19-2.56a2.44 2.44 0 0 1 .9 1.39c.06.36 0 .84-.48.73a1.76 1.76 0 0 1-1.31-1.87 2.64 2.64 0 0 1 .14-.69 3.35 3.35 0 0 1 .75.48Zm4.89-1.18a1 1 0 0 1-.21 1.15c-.3.32-.73.62-1.16.35-.95-.63-.93-1.67-.71-2.7a2.46 2.46 0 0 1 .14-.38 3 3 0 0 1 1.97 1.58Zm3.54-1.13c-.1.34-.4.72-.79.5a1.3 1.3 0 0 1-.58-1.42 3.71 3.71 0 0 1 .8-1.47 2.43 2.43 0 0 1 .57 2.39Zm4.73-.7a1.38 1.38 0 0 1-1 1 .88.88 0 0 1-.92-.57 1.17 1.17 0 0 1 .11-1 4.53 4.53 0 0 1 1.16-1.42 2.89 2.89 0 0 1 .38.4 1.77 1.77 0 0 1 .27 1.64Zm5.26 0a2.14 2.14 0 0 1-1.18 1.18c-.32.13-.85.18-1-.2a1.49 1.49 0 0 1 .24-1.4 2.26 2.26 0 0 1 1.07-.86 3.56 3.56 0 0 1 .81-.2 1.71 1.71 0 0 1 .06 1.53Zm3.34 2.71c-.12.05-.26.17-.38.17a.66.66 0 0 1-.32 0c-.26-.15-.44-.26-.5-.56a1.61 1.61 0 0 1 .9-1.88 2.11 2.11 0 0 1 1-.16s0-.26 0 .21.04 1.89-.7 2.23Z",
    id: "elaheq71u0pz9",
    className: "animable",
    style: {
      transformOrigin: "212.176px 148.012px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.41Z",
    id: "elt1uyecb0xmm",
    className: "animable",
    style: {
      transformOrigin: "188.5px 161.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.42Z",
    id: "eluvtc8v20nf",
    className: "animable",
    style: {
      transformOrigin: "188.5px 161.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "eltqgco28chzd",
    className: "animable",
    style: {
      transformOrigin: "188.5px 161.42px"
    },
    d: "M188.5 161.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 161.42Z",
    id: "el9xzjqp5z1iu",
    className: "animable",
    style: {
      transformOrigin: "188.5px 161.42px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246.385px 160.761px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "233.235px 149.74px"
    },
    id: "elsscrjea9pk",
    className: "animable",
    d: "m206.96 156.87 38.64-22.3 13.91 8.03-38.65 22.31-13.9-8.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.65 161.91-7.41-4.28a.61.61 0 0 1 0-1.16l7.46-4.3a2.2 2.2 0 0 1 2 0l7.37 4.3a.61.61 0 0 1 0 1.16l-7.41 4.28a2.2 2.2 0 0 1-2.01 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "219.655px 157.041px"
    },
    id: "elkw0vvnxj6qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.7 153.62-7.21 4.16 7.16 4.13a2.2 2.2 0 0 0 2 0l7.17-4.13-7.12-4.16a2.2 2.2 0 0 0-2 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "219.655px 157.765px"
    },
    id: "el4ndwkfz3bq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245 146.69-7.41-4.28a.61.61 0 0 1 0-1.16l7.46-4.31a2.22 2.22 0 0 1 2 0l7.36 4.3a.61.61 0 0 1 0 1.16l-7.41 4.29a2.22 2.22 0 0 1-2 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "246px 141.815px"
    },
    id: "elsc275e50zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247 146.69 7.16-4.14-7.11-4.15a2.22 2.22 0 0 0-2 0l-7.2 4.16 7.15 4.13a2.22 2.22 0 0 0 2 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "246.005px 142.545px"
    },
    id: "elw76beqrcjje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 161.34v2.56a1.77 1.77 0 0 0 .87 1.52l36.87 21.3a1.78 1.78 0 0 0 1.76 0l35.34-20.41a1.74 1.74 0 0 0 .88-1.52v-2.55L248 183.15a1.76 1.76 0 0 1-1.75 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "246.36px 174.146px"
    },
    id: "el8pcb17dt2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "253.3px 157.77px"
    },
    id: "el56jvoqa9xav",
    className: "animable",
    d: "M285.76 150.63v7.14l-38.64 22.31-26.28-15.17 24.73-14.28 13.92-15.17 26.27 15.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.86 165.8-24.74 14.28L207 156.87v2.56a1.77 1.77 0 0 0 .88 1.52l38.41 22.2a1.76 1.76 0 0 0 1.75 0l36.89-21.3a1.76 1.76 0 0 0 .88-1.52v-9.7Z",
    style: {
      fill: "#37474f",
      transformOrigin: "246.405px 167.006px"
    },
    id: "elcwmm7nktwui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247 180-40-23.12v2.56a1.77 1.77 0 0 0 .88 1.52l38.41 22.2a1.78 1.78 0 0 0 .71.22Z",
    style: {
      fill: "#263238",
      transformOrigin: "227px 170.13px"
    },
    id: "elve1hje0s11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.25 183.15-37.75-21.81v2.56a1.77 1.77 0 0 0 .87 1.52l36.87 21.3a1.72 1.72 0 0 0 .72.22v-3.57a1.78 1.78 0 0 1-.71-.22Z",
    id: "el4vaby9t2mnp",
    className: "animable",
    style: {
      transformOrigin: "227.73px 174.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "265.665px 143.045px"
    },
    className: "animable",
    d: "m285.76 150.63-26.25-14.09-13.94 14.09 13.92-15.17 26.27 15.17z",
    id: "elfr6gz1jlri4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "261.87px 159.885px"
    },
    className: "animable",
    d: "m271.86 165.8-20.5-11.83 21.02 11.26-.52.57z",
    id: "el8fg78s26528"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "232.97px 157.77px"
    },
    id: "elekk574zl5il",
    className: "animable",
    d: "m245.57 150.63-24.71 14.28-.49-.29 25.2-13.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "268.045px 147.495px"
    },
    id: "elhqpy9h5c7w",
    className: "animable",
    d: "m275.21 155.42-18.83-10.87 4.55-4.98 18.78 10.84-4.5 5.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "268.045px 145.225px"
    },
    className: "animable",
    d: "m279.29 150.88.42-.47-18.78-10.84-4.55 4.98.56.33 4.13-4.52 18.22 10.52z",
    id: "elcvfm2dgha4f"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "258.725px 142.225px"
    },
    className: "animable",
    d: "m261.07 140.36-.14-.79-4.55 4.98.56.33 4.13-4.52z",
    id: "elblf28uqppu6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.52 155-6.47-3.76 1.1-1.2 6.45 3.75a.37.37 0 0 1 .09.58l-.46.51a.59.59 0 0 1-.71.12Z",
    style: {
      fill: "#fff",
      transformOrigin: "255.921px 152.555px"
    },
    id: "elwctbtvvblk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6 149.85a.2.2 0 0 0-.12-.15l-1.11-.64a.38.38 0 0 0-.45.08l-1 1.05a.23.23 0 0 0-.07.2c0 .06.09.36.1.43a.26.26 0 0 0 .12.15l1.11.64a.4.4 0 0 0 .45-.08l1-1.05a.21.21 0 0 0 .06-.21c0-.06-.07-.35-.09-.42Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.273px 150.333px"
    },
    id: "el5qel8b4pwch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.49 151.63a.29.29 0 0 0 .18-.1l1-1.05a.21.21 0 0 0 .06-.21c0-.06-.08-.35-.1-.42a.2.2 0 0 0-.12-.15l-1.11-.64a.35.35 0 0 0-.25 0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "252.944px 150.333px"
    },
    className: "animable",
    id: "elprxjvnwp6rs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12 149a.33.33 0 0 0-.2.11l-1 1.05a.23.23 0 0 0-.07.2c0 .06.09.36.1.43a.26.26 0 0 0 .12.15l1.11.64a.36.36 0 0 0 .27 0Z",
    style: {
      opacity: 0.3,
      transformOrigin: "251.649px 150.303px"
    },
    className: "animable",
    id: "el0odn5n8yi2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.58 151.11 1-1.05a.22.22 0 0 0-.06-.36l-1.11-.64a.38.38 0 0 0-.45.08l-1 1.05a.22.22 0 0 0 0 .36l1.11.63a.39.39 0 0 0 .51-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.258px 150.132px"
    },
    id: "el2qn1b6c917b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.08 152.23-6.47-3.75 1.1-1.2 6.45 3.75a.36.36 0 0 1 .09.58l-.46.51a.59.59 0 0 1-.71.11Z",
    style: {
      fill: "#fff",
      transformOrigin: "258.484px 149.791px"
    },
    id: "elek6jhyl39a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17 147.05a.31.31 0 0 0-.12-.16l-1.11-.63a.38.38 0 0 0-.45.07l-1 1.06a.2.2 0 0 0-.06.2c0 .06.08.36.1.43a.22.22 0 0 0 .12.15l1.11.63a.38.38 0 0 0 .45-.07l1-1a.25.25 0 0 0 .07-.21c-.03-.11-.1-.4-.11-.47Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "254.853px 147.53px"
    },
    id: "elqq5c5osuf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.06 148.83a.4.4 0 0 0 .18-.1l1-1a.25.25 0 0 0 .07-.21c0-.06-.09-.35-.1-.42a.31.31 0 0 0-.12-.16l-1.11-.63a.37.37 0 0 0-.25 0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "255.521px 147.559px"
    },
    className: "animable",
    id: "el4686svnuwzb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69 146.23a.35.35 0 0 0-.2.1l-1 1.06a.2.2 0 0 0-.06.2c0 .06.08.36.1.43a.22.22 0 0 0 .12.15l1.11.63a.36.36 0 0 0 .27 0Z",
    style: {
      opacity: 0.3,
      transformOrigin: "254.227px 147.528px"
    },
    className: "animable",
    id: "elqoj0xeyzdzc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.14 148.31 1-1.06a.23.23 0 0 0-.06-.36l-1.11-.63a.38.38 0 0 0-.45.07l-1 1.06a.21.21 0 0 0 .06.35l1.11.64a.4.4 0 0 0 .45-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "254.826px 147.318px"
    },
    id: "elkj7458bkoqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.29 161.25-6.47-3.76 1.1-1.19 6.45 3.74a.37.37 0 0 1 .09.58l-.46.52a.59.59 0 0 1-.71.11Z",
    style: {
      fill: "#fff",
      transformOrigin: "266.691px 158.811px"
    },
    id: "elwkcxtsdvord",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38 156.06a.29.29 0 0 0-.12-.15l-1.11-.63a.39.39 0 0 0-.46.07l-1 1.05a.21.21 0 0 0-.06.21c0 .06.08.36.09.42a.31.31 0 0 0 .12.16l1.11.63a.39.39 0 0 0 .46-.07l1-1.05a.22.22 0 0 0 .06-.21c-.01-.06-.08-.36-.09-.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "263.049px 156.55px"
    },
    id: "elg7dcqgnoarn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27 157.85a.4.4 0 0 0 .18-.1l1-1.05a.22.22 0 0 0 .06-.21c0-.06-.08-.36-.09-.43a.29.29 0 0 0-.12-.15l-1.11-.63a.44.44 0 0 0-.25 0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "263.728px 156.556px"
    },
    className: "animable",
    id: "elqapzvyo6zba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9 155.24a.43.43 0 0 0-.21.11l-1 1.05a.21.21 0 0 0-.06.21c0 .06.08.36.09.42a.31.31 0 0 0 .12.16l1.11.63a.45.45 0 0 0 .28 0Z",
    style: {
      opacity: 0.3,
      transformOrigin: "262.426px 156.541px"
    },
    className: "animable",
    id: "eliguqalh42i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.35 157.32 1-1a.22.22 0 0 0-.05-.36l-1.11-.63a.39.39 0 0 0-.46.07l-1 1.05a.22.22 0 0 0 .06.36l1.11.63a.38.38 0 0 0 .45-.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "263.042px 156.377px"
    },
    id: "elm1infq1d81m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.86 158.45-6.47-3.76 1.1-1.2 6.45 3.75a.37.37 0 0 1 .09.58l-.46.52a.59.59 0 0 1-.71.11Z",
    style: {
      fill: "#fff",
      transformOrigin: "269.261px 156.006px"
    },
    id: "elqdp4q8z10uk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94 153.26a.22.22 0 0 0-.12-.15l-1.11-.63a.38.38 0 0 0-.45.07l-1 1a.26.26 0 0 0-.06.2c0 .06.08.36.1.43a.2.2 0 0 0 .12.15l1.11.64a.4.4 0 0 0 .47.03l1-1.06a.26.26 0 0 0 .06-.2c-.06-.11-.06-.41-.12-.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.63px 153.749px"
    },
    id: "elusl41tmd76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83 155a.31.31 0 0 0 .17 0l1-1.06a.26.26 0 0 0 .06-.2c0-.06-.08-.36-.1-.43a.22.22 0 0 0-.12-.15l-1.11-.63a.31.31 0 0 0-.25 0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "266.271px 153.758px"
    },
    className: "animable",
    id: "elc9trh10tahv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.46 152.44a.31.31 0 0 0-.2.11l-1 1a.26.26 0 0 0-.06.2c0 .06.08.36.1.43a.2.2 0 0 0 .12.15l1.11.64a.36.36 0 0 0 .27 0Z",
    style: {
      opacity: 0.3,
      transformOrigin: "264.999px 153.718px"
    },
    className: "animable",
    id: "elmn0p67eynee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.91 154.52 1-1.05a.22.22 0 0 0-.06-.36l-1.11-.63a.38.38 0 0 0-.45.07l-1 1a.23.23 0 0 0 .06.36l1.11.63a.38.38 0 0 0 .45-.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.603px 153.52px"
    },
    id: "elzibj5z0z04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246 153.58-2.29 1.33a.59.59 0 0 0 0 1.11l1 .58a2.12 2.12 0 0 0 1.93 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.12 2.12 0 0 0-1.94 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "246.325px 155.089px"
    },
    id: "el172etgyivmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2 155.11a1.28 1.28 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.69.69 0 0 0 .39-.56v-.76a.57.57 0 0 1-.17.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "246.365px 156.166px"
    },
    id: "elew3tkc5i8uo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.58 157.35-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.18 2.18 0 0 0 1.93 0l2.3-1.33a.58.58 0 0 0 0-1.1l-1-.59a2.1 2.1 0 0 0-1.93 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.898px 158.855px"
    },
    id: "el7c2ens8r6zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74 158.87a1 1 0 0 1-.22.17l-2.3 1.33a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.75a.69.69 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.91px 159.929px"
    },
    id: "el92075khpy9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.67 160.3-2.29 1.32c-.54.31-.54.8 0 1.11l1 .59a2.18 2.18 0 0 0 1.93 0l2.3-1.33a.58.58 0 0 0 0-1.1l-1-.59a2.12 2.12 0 0 0-1.94 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.99px 161.805px"
    },
    id: "el39g5csxakir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84 161.82a1.08 1.08 0 0 1-.23.18l-2.29 1.32a2.18 2.18 0 0 1-1.93 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.15 2.15 0 0 0 1.93 0l2.29-1.33a.66.66 0 0 0 .4-.55v-.77a.55.55 0 0 1-.17.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "258px 162.869px"
    },
    id: "el17lp7ki7gi3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.71 163.24-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.1 2.1 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "263.02px 164.75px"
    },
    id: "ely0k8d2qutzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.87 164.77a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.61.61 0 0 1-.18-.37v.75a.68.68 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.77a.54.54 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "263.04px 165.821px"
    },
    id: "elnb4wntqfdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.6 156.72-2.3 1.28a.59.59 0 0 0 0 1.11l1 .59a2.16 2.16 0 0 0 1.92 0l2.3-1.32c.54-.31.54-.81 0-1.11l-1-.59a2.1 2.1 0 0 0-1.92.04Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "240.918px 158.196px"
    },
    id: "el3dkurwxm77t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76 158.24a.67.67 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.37 1.37 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.07 2.07 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "240.93px 159.293px"
    },
    id: "el21lr4nvezro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.14 160.48-2.29 1.33a.59.59 0 0 0 0 1.11l1 .58a2.12 2.12 0 0 0 1.93 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.12 2.12 0 0 0-1.94 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "247.465px 161.989px"
    },
    id: "el00l8h9x6mke37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 162a1.28 1.28 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.59.59 0 0 1-.18-.36v.74a.66.66 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.69.69 0 0 0 .39-.56v-.76a.57.57 0 0 1-.17.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "247.475px 163.056px"
    },
    id: "elv0h7ya59cq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.24 163.43-2.3 1.33a.59.59 0 0 0 0 1.11l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32c.53-.31.54-.8 0-1.11l-1-.59a2.16 2.16 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.556px 164.944px"
    },
    id: "el9xqofv9xb0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 165a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.52 1.52 0 0 1-.23-.16.57.57 0 0 1-.17-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.57px 166.056px"
    },
    id: "ell7zoyhm1tog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27 166.38 255 167.7a.59.59 0 0 0 0 1.11l1 .59a2.18 2.18 0 0 0 1.93 0l2.3-1.33a.58.58 0 0 0 0-1.1l-1-.59a2.12 2.12 0 0 0-1.96 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.618px 167.883px"
    },
    id: "elz2q8lk1ks8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44 167.9a1.28 1.28 0 0 1-.22.17l-2.3 1.33a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.72a.67.67 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.56.56 0 0 1-.18.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.61px 168.929px"
    },
    id: "elyor398nkoqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.17 159.85-2.3 1.33a.59.59 0 0 0 0 1.11l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.16 2.16 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "235.48px 161.364px"
    },
    id: "elv5kst12uyt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33 161.38a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59-.22-.16a.65.65 0 0 1-.18-.36v.74a.69.69 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.56V161a.54.54 0 0 1-.18.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "235.5px 162.434px"
    },
    id: "el0b0njcrkuz3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.71 163.62-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.16 2.16 0 0 0 1.92 0l2.3-1.32c.54-.31.54-.81 0-1.11l-1-.59a2.1 2.1 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "242.028px 165.126px"
    },
    id: "elzjbcfsjdug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87 165.14a.82.82 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.37 1.37 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "242.04px 166.189px"
    },
    id: "elq9r9akbrlli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.81 166.57-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.16 2.16 0 0 0 1.92 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.1 2.1 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "247.12px 168.076px"
    },
    id: "elenxmj5th7oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 168.09a.67.67 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.75a.68.68 0 0 0 .4.55l1 .58a2.07 2.07 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "247.17px 169.143px"
    },
    id: "el8ganl1e36r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.84 169.51-2.29 1.33c-.54.3-.54.8 0 1.11l1 .58a2.1 2.1 0 0 0 1.92 0l2.31-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.1 2.1 0 0 0-1.94 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.157px 171.017px"
    },
    id: "el613d8b36opp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 171a1.06 1.06 0 0 1-.23.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.54.54 0 0 1-.18-.36v.74a.65.65 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.77a.57.57 0 0 1-.17.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.16px 172.051px"
    },
    id: "el6djxlawjpg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.74 163-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.12 2.12 0 0 0 1.93 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.1 2.1 0 0 0-1.93 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "230.055px 164.509px"
    },
    id: "eldudus6jx655",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9 164.52a1 1 0 0 1-.22.17l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.57.57 0 0 1-.18-.36v.75a.68.68 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.54.54 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "230.07px 165.571px"
    },
    id: "elb59sju5dn66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.28 166.75-2.3 1.33a.59.59 0 0 0 0 1.11l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.16 2.16 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.59px 168.264px"
    },
    id: "elmarlytzr1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44 168.28a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59-.22-.16a.65.65 0 0 1-.18-.36v.74a.69.69 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.61px 169.336px"
    },
    id: "elsoyucaxkdnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.37 169.7-2.29 1.3a.59.59 0 0 0 0 1.11l1 .58a2.12 2.12 0 0 0 1.93 0l2.3-1.32a.59.59 0 0 0 0-1.11l-1-.59a2.18 2.18 0 0 0-1.94.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "241.695px 171.19px"
    },
    id: "el7jieyfz3m2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54 171.23a1 1 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.58a1.4 1.4 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.71.71 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "241.71px 172.279px"
    },
    id: "elmw4mx9bfonf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.41 172.65-2.3 1.32a.59.59 0 0 0 0 1.11l1 .59a2.16 2.16 0 0 0 1.92 0l2.3-1.32c.53-.31.54-.81 0-1.11l-1-.59a2.1 2.1 0 0 0-1.92 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "246.726px 174.156px"
    },
    id: "eljfk06ljpgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.57 174.17a.82.82 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.06 1.06 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "246.74px 175.219px"
    },
    id: "elemt83u0su2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "246.555px 165.694px"
    },
    className: "animable",
    id: "elkl52fmqrd4k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.2 155.11a1.28 1.28 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.69.69 0 0 0 .39-.56v-.76a.57.57 0 0 1-.17.38Z",
    id: "el7tqo6tie45u",
    className: "animable",
    style: {
      transformOrigin: "246.365px 156.166px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74 158.87a1 1 0 0 1-.22.17l-2.3 1.33a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.75a.69.69 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.38Z",
    id: "elzsuqtqck3vf",
    className: "animable",
    style: {
      transformOrigin: "252.91px 159.929px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84 161.82a1.08 1.08 0 0 1-.23.18l-2.29 1.32a2.18 2.18 0 0 1-1.93 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.15 2.15 0 0 0 1.93 0l2.29-1.33a.66.66 0 0 0 .4-.55v-.77a.55.55 0 0 1-.17.39Z",
    id: "elx6sx3uojkfp",
    className: "animable",
    style: {
      transformOrigin: "258px 162.869px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.87 164.77a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.61.61 0 0 1-.18-.37v.75a.68.68 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.77a.54.54 0 0 1-.18.39Z",
    id: "el7xln3ryy7x",
    className: "animable",
    style: {
      transformOrigin: "263.04px 165.821px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76 158.24a.67.67 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.37 1.37 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.07 2.07 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    id: "elgn7clm7hwhl",
    className: "animable",
    style: {
      transformOrigin: "240.93px 159.293px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 162a1.28 1.28 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.59.59 0 0 1-.18-.36v.74a.66.66 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.69.69 0 0 0 .39-.56v-.76a.57.57 0 0 1-.17.38Z",
    id: "el1tmylhg626p",
    className: "animable",
    style: {
      transformOrigin: "247.475px 163.056px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 165a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.52 1.52 0 0 1-.23-.16.57.57 0 0 1-.17-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.38Z",
    id: "eljro6go2w2m",
    className: "animable",
    style: {
      transformOrigin: "252.57px 166.056px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44 167.9a1.28 1.28 0 0 1-.22.17l-2.3 1.33a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.72a.67.67 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.56.56 0 0 1-.18.41Z",
    id: "el089gz9t7zl1c",
    className: "animable",
    style: {
      transformOrigin: "257.61px 168.929px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33 161.38a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59-.22-.16a.65.65 0 0 1-.18-.36v.74a.69.69 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.56V161a.54.54 0 0 1-.18.38Z",
    id: "elglhuz1e9sh6",
    className: "animable",
    style: {
      transformOrigin: "235.5px 162.434px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87 165.14a.82.82 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.37 1.37 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    id: "ellu8guia143n",
    className: "animable",
    style: {
      transformOrigin: "242.04px 166.189px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 168.09a.67.67 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.75a.68.68 0 0 0 .4.55l1 .58a2.07 2.07 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    id: "ellg281bg9ga",
    className: "animable",
    style: {
      transformOrigin: "247.17px 169.143px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 171a1.06 1.06 0 0 1-.23.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59a1.4 1.4 0 0 1-.22-.16.54.54 0 0 1-.18-.36v.74a.65.65 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.77a.57.57 0 0 1-.17.39Z",
    id: "elyna3ks7hu0q",
    className: "animable",
    style: {
      transformOrigin: "252.16px 172.051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9 164.52a1 1 0 0 1-.22.17l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1 1 0 0 1-.22-.17.57.57 0 0 1-.18-.36v.75a.68.68 0 0 0 .4.55l1 .59a2.1 2.1 0 0 0 1.92 0l2.3-1.33a.68.68 0 0 0 .4-.55v-.77a.54.54 0 0 1-.18.39Z",
    id: "elxe6cyib2qc",
    className: "animable",
    style: {
      transformOrigin: "230.07px 165.571px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44 168.28a.8.8 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.59-.22-.16a.65.65 0 0 1-.18-.36v.74a.69.69 0 0 0 .4.56l1 .58a2.1 2.1 0 0 0 1.92 0l2.3-1.32a.68.68 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.38Z",
    id: "eltv1ssjsul3a",
    className: "animable",
    style: {
      transformOrigin: "236.61px 169.336px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54 171.23a1 1 0 0 1-.22.17l-2.3 1.32a2.1 2.1 0 0 1-1.92 0l-1-.58a1.4 1.4 0 0 1-.22-.17.59.59 0 0 1-.18-.36v.74a.67.67 0 0 0 .4.56l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.71.71 0 0 0 .4-.56v-.76a.54.54 0 0 1-.18.39Z",
    id: "elw6zq3sgzfzk",
    className: "animable",
    style: {
      transformOrigin: "241.71px 172.279px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.57 174.17a.82.82 0 0 1-.22.18l-2.3 1.32a2.16 2.16 0 0 1-1.92 0l-1-.59a1.06 1.06 0 0 1-.23-.17.57.57 0 0 1-.17-.36v.75a.66.66 0 0 0 .4.55l1 .58a2.13 2.13 0 0 0 1.92 0l2.3-1.33a.66.66 0 0 0 .4-.55v-.77a.52.52 0 0 1-.18.39Z",
    id: "eli08d2snfj7b",
    className: "animable",
    style: {
      transformOrigin: "246.74px 175.219px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.24 144.47a.22.22 0 0 1 .06-.12l1.84-2.23a.21.21 0 0 1 .12-.08.17.17 0 0 1 .13 0l1.15.65s.06.05 0 .09 0 .07-.07.13l-.08.09a.35.35 0 0 1-.12.1.11.11 0 0 1-.11 0l-.76-.43-.51.62.68.39s.05 0 0 .08a.23.23 0 0 1-.07.13l-.07.09a.44.44 0 0 1-.12.1.09.09 0 0 1-.11 0l-.68-.38-.56.68.76.43a.08.08 0 0 1 .05.08.32.32 0 0 1-.08.13l-.07.09a.54.54 0 0 1-.12.11.14.14 0 0 1-.11 0l-1.16-.66a.16.16 0 0 1 .01-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "260.897px 143.629px"
    },
    id: "elmbubzti3e3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.07 145.41 1.87-2.26a.17.17 0 0 1 .12-.08.21.21 0 0 1 .13 0l.64.37c.53.3.61.67.24 1.13a1 1 0 0 1-.88.38.67.67 0 0 1-.05.54l-.33.82c0 .05-.14 0-.28 0l-.12-.07c-.12-.07-.17-.13-.13-.2l.35-.8a.53.53 0 0 0 0-.23.32.32 0 0 0-.15-.16l-.15-.08-.73.88c-.06.07-.15.06-.29 0l-.11-.06c-.15-.04-.2-.11-.13-.18Zm1.89-.86a.29.29 0 0 0 .26 0 .64.64 0 0 0 .29-.21.45.45 0 0 0 .13-.3.21.21 0 0 0-.13-.19l-.27-.15-.56.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.669px 144.696px"
    },
    id: "elnei11uwiqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.1 146.57 1.9-2.27a.21.21 0 0 1 .11-.08.16.16 0 0 1 .13 0l.64.36c.53.3.61.68.24 1.13a1 1 0 0 1-.87.39.65.65 0 0 1 0 .55l-.33.82c0 .06-.14 0-.28 0l-.11-.06c-.13-.07-.17-.14-.14-.2l.35-.81a.53.53 0 0 0 0-.23.35.35 0 0 0-.15-.15l-.15-.09-.73.88c-.05.07-.15.07-.29 0l-.11-.06c-.23-.04-.31-.11-.21-.18Zm1.89-.86a.33.33 0 0 0 .26 0 .66.66 0 0 0 .29-.22.45.45 0 0 0 .14-.29.23.23 0 0 0-.14-.19l-.27-.16-.56.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "264.703px 145.851px"
    },
    id: "elvlg7ecvr5hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 146.52c.7-.84 1.39-1.07 2.07-.68s.67 1 0 1.84-1.4 1.08-2.08.7-.69-1.01.01-1.86Zm.82 1.47a2.22 2.22 0 0 0 .68-.61 1.9 1.9 0 0 0 .44-.74.35.35 0 0 0-.2-.4.55.55 0 0 0-.53 0 2.19 2.19 0 0 0-.67.61 1.72 1.72 0 0 0-.44.74.35.35 0 0 0 .2.41.56.56 0 0 0 .53 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "267.027px 147.105px"
    },
    id: "elhbqi94aydc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.5 149.07 1.88-2.27a.23.23 0 0 1 .12-.08.24.24 0 0 1 .13 0l.63.36c.53.31.61.68.24 1.13a1 1 0 0 1-.87.39.71.71 0 0 1-.05.54l-.34.82c0 .06-.14.05-.28 0l-.12-.07c-.12-.07-.17-.14-.14-.2l.3-.69a.33.33 0 0 0 0-.23q0-.08-.15-.15l-.14-.08-.73.88c-.06.07-.16.06-.3 0l-.11-.06c-.08-.15-.12-.22-.07-.29Zm1.9-.86a.29.29 0 0 0 .26 0 .69.69 0 0 0 .28-.21.49.49 0 0 0 .14-.3.25.25 0 0 0-.13-.19l-.27-.15-.57.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "269.103px 148.356px"
    },
    id: "elmf5qg95nlxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2 150.73a.69.69 0 0 1-.18-.23.19.19 0 0 1 0-.17.67.67 0 0 1 .2-.11c.1 0 .16-.05.2 0s0 0 .06.09a.61.61 0 0 0 .12.16.58.58 0 0 0 .19.15.46.46 0 0 0 .38 0 .66.66 0 0 0 .37-.24c.23-.29.19-.52-.13-.7l-.34-.2c-.06 0-.08-.06-.08-.09s0-.07.05-.12l.94-1a.2.2 0 0 1 .13-.08.22.22 0 0 1 .13 0l1 .59s.06 0 .05.08a.19.19 0 0 1-.07.13l-.06.08a.39.39 0 0 1-.11.09.12.12 0 0 1-.1 0l-.73-.41-.53.56.1.06a.74.74 0 0 1 .23 1.28 1.08 1.08 0 0 1-.76.45 1.25 1.25 0 0 1-.78-.17 1.39 1.39 0 0 1-.28-.2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "271.646px 149.644px"
    },
    id: "eled4k00jhadv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.13 151.4a2.4 2.4 0 0 1 .58-1.06 2.94 2.94 0 0 1 1-.83.9.9 0 0 1 .86 0 .61.61 0 0 1 .33.66 2.37 2.37 0 0 1-.58 1.07 3.06 3.06 0 0 1-1 .83.92.92 0 0 1-.87 0 .6.6 0 0 1-.32-.67Zm.84.31a1.09 1.09 0 0 0 .33-.22 8 8 0 0 0 .92-1.11.89.89 0 0 0 .13-.33.15.15 0 0 0-.09-.17.24.24 0 0 0-.22 0 1.07 1.07 0 0 0-.32.22 5.92 5.92 0 0 0-.49.54 4.9 4.9 0 0 0-.43.58.84.84 0 0 0-.14.33.17.17 0 0 0 .09.16.24.24 0 0 0 .25 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "273.513px 150.79px"
    },
    id: "elevp1jyk8p28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.74 152.69q-.18-.21-.09-.33a.52.52 0 0 1 .19-.11q.14-.06.18 0a.25.25 0 0 1 .07.09 1 1 0 0 0 .13.19.7.7 0 0 0 .18.14.57.57 0 0 0 .38.07.58.58 0 0 0 .38-.23.47.47 0 0 0 .13-.37.53.53 0 0 0-.28-.3l-.15-.08a.08.08 0 0 1-.05-.08.23.23 0 0 1 .07-.14.35.35 0 0 1 .13-.1.11.11 0 0 1 .11 0l.11.06a.53.53 0 0 0 .4.07.56.56 0 0 0 .32-.18.34.34 0 0 0 .1-.27.33.33 0 0 0-.19-.24.8.8 0 0 0-.21-.08h-.28s-.05-.07 0-.15a.43.43 0 0 1 .06-.19c.06-.07.18-.09.35-.05a1.68 1.68 0 0 1 .52.2.76.76 0 0 1 .41.47.68.68 0 0 1-.17.57.86.86 0 0 1-.37.26.93.93 0 0 1-.44 0 .62.62 0 0 1 .14.43.79.79 0 0 1-.21.48 1.12 1.12 0 0 1-.44.34 1.08 1.08 0 0 1-.5.09 1.16 1.16 0 0 1-.51-.15 2.13 2.13 0 0 1-.47-.41Z",
    style: {
      fill: "#455a64",
      transformOrigin: "275.169px 151.821px"
    },
    id: "el5zcytsbzqgm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "206.635px 177.719px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.94 182.35-3.7 2.14-5.13 3-17.8-10.28 5.39-3.11 4.67-2.7a8.9 8.9 0 0 0 3.07 3.2l9 5.22a4.56 4.56 0 0 0 1.81.61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "206.625px 179.445px"
    },
    id: "el7d67pbpmex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.94 182.35-3.7 2.14-5.13 3-17.8-10.28 5.39-3.11 4.67-2.7a8.9 8.9 0 0 0 3.07 3.2l9 5.22a4.56 4.56 0 0 0 1.81.61Z",
    style: {
      opacity: 0.1,
      transformOrigin: "206.625px 179.445px"
    },
    className: "animable",
    id: "el69c70udioob"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21 182.6v3.06a2.86 2.86 0 0 1-1.35 2.38l-.78.46-8.57 5a3.16 3.16 0 0 0 1.88-2.72v-3.08a2.07 2.07 0 0 0 1-.24l7.41-4.28a.71.71 0 0 0 .41-.58Z",
    style: {
      fill: "#263238",
      transformOrigin: "223.86px 188.05px"
    },
    id: "el5f0vpz5axkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.37 171.36-4.67 2.7-4.16 2.4A5.38 5.38 0 0 1 194 175l-.64-2.9a2 2 0 0 0 1-.23l7.41-4.28a.75.75 0 0 0 .41-.53l.63 2.86a5.46 5.46 0 0 0 .56 1.44Z",
    style: {
      fill: "#263238",
      transformOrigin: "198.365px 171.76px"
    },
    id: "elyx0asl3mrdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.38 187.46-7.86-4.53a.83.83 0 0 1-.4-.49v-.09s-.32 1-.72 2.13-2.07 1.36-3.74.4l-9-5.22A8.51 8.51 0 0 1 194 175l-.64-2.91a2.13 2.13 0 0 1-1-.23l-7.85-4.54a.69.69 0 0 1-.42-.57v3.9a8.44 8.44 0 0 0 1.5 3.94 22.86 22.86 0 0 0 6.86 6.34s16.5 9.55 19.63 11.33 5.53 1.78 6.47 1.24a3.16 3.16 0 0 0 1.88-2.72v-3.08a2 2 0 0 1-1.05-.24Z",
    style: {
      fill: "#37474f",
      transformOrigin: "202.26px 180.283px"
    },
    id: "elj8xq5i016wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.32 171.84 7.41-4.28a.61.61 0 0 0 0-1.16l-7.85-4.54a2.22 2.22 0 0 0-2 0l-7.41 4.28a.61.61 0 0 0 0 1.16l7.85 4.54a2.22 2.22 0 0 0 2 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "193.1px 166.85px"
    },
    id: "elyj76bnpfjdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6 168.87c-1.93-1.11-1.93-2.92 0-4a7.72 7.72 0 0 1 7 0c1.93 1.12 1.93 2.92 0 4a7.75 7.75 0 0 1-7 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "193.1px 166.868px"
    },
    id: "el00vns7dyfv2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.92,
    cy: 165.61,
    rx: 0.52,
    ry: 0.3,
    style: {
      fill: "#263238",
      transformOrigin: "190.92px 165.61px"
    },
    id: "eluyh6hu6vmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.15 166.29c.29 0 .48.18.43.34s-.31.28-.59.25-.47-.18-.43-.34.31-.27.59-.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "190.071px 166.586px"
    },
    id: "elzc4hxjn4mt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.15 167.4a.7.7 0 0 1 .69.13c.13.15 0 .33-.22.4a.72.72 0 0 1-.7-.13c-.13-.15-.03-.33.23-.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "190.377px 167.665px"
    },
    id: "ellck7kdnfzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27 168.29a.76.76 0 0 1 .69-.13c.26.08.36.26.23.4a.74.74 0 0 1-.7.14c-.25-.08-.35-.26-.22-.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "191.73px 168.431px"
    },
    id: "elj9ekcihet6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.08 168.64c0-.17.15-.32.44-.34s.54.08.59.24-.15.32-.43.35-.55-.09-.6-.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "193.599px 168.596px"
    },
    id: "eleuppwef01o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91 168.3c-.21-.12-.21-.31 0-.42a.79.79 0 0 1 .73 0c.2.11.2.3 0 .42a.79.79 0 0 1-.73 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "195.271px 168.09px"
    },
    id: "el8yl8wvr6ny3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 167.41c-.29 0-.48-.18-.44-.34s.31-.28.6-.25.47.18.43.34-.27.27-.59.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "196.075px 167.114px"
    },
    id: "elbjwlqsjpe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 166.3a.72.72 0 0 1-.7-.13c-.13-.14 0-.32.23-.4a.72.72 0 0 1 .7.13c.17.15.07.33-.23.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "195.781px 166.035px"
    },
    id: "elll41in2wac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.92 165.41a.77.77 0 0 1-.7.13c-.25-.08-.35-.26-.22-.4a.7.7 0 0 1 .69-.13c.31.07.36.25.23.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "194.465px 165.272px"
    },
    id: "elwwxvad57qf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 165.06c.05.17-.14.32-.43.35s-.55-.09-.59-.25.15-.32.43-.35.55.09.59.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "192.591px 165.11px"
    },
    id: "elhf0wqwauoqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.39 187.46 7.41-4.28a.61.61 0 0 0 0-1.16l-7.86-4.53a2.22 2.22 0 0 0-2 0l-7.41 4.28a.61.61 0 0 0 0 1.15l7.86 4.54a2.22 2.22 0 0 0 2 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "220.172px 182.475px"
    },
    id: "elikuy3w6oz1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67 184.49c-1.93-1.11-1.93-2.91 0-4a7.69 7.69 0 0 1 7 0c1.92 1.11 1.92 2.92 0 4a7.72 7.72 0 0 1-7 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "220.166px 182.488px"
    },
    id: "el8i4p162f5ne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35 181a.23.23 0 0 1 0 .43.85.85 0 0 1-.73 0c-.21-.12-.21-.31 0-.43a.85.85 0 0 1 .73 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "217.98px 181.215px"
    },
    id: "elvvg7qcefq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22 181.92c.28 0 .47.18.43.34s-.31.27-.59.25-.48-.18-.43-.35.31-.27.59-.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "217.139px 182.214px"
    },
    id: "eli9lii4iflm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21 183a.74.74 0 0 1 .7.13c.13.15 0 .33-.23.4a.7.7 0 0 1-.69-.13c-.13-.12.01-.3.22-.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "217.451px 183.266px"
    },
    id: "elpu2jh65nmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.33 183.92a.72.72 0 0 1 .7-.13c.25.07.36.25.23.4a.75.75 0 0 1-.7.13c-.26-.08-.36-.26-.23-.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "218.794px 184.053px"
    },
    id: "elchxtdir4jrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.15 184.26c0-.16.15-.32.43-.34s.55.08.59.25-.14.31-.43.34-.54-.09-.59-.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "220.663px 184.216px"
    },
    id: "el46bfpojslh4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 183.92c-.2-.11-.2-.3 0-.42a.79.79 0 0 1 .73 0c.21.12.21.31 0 .42a.79.79 0 0 1-.73 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "222.369px 183.71px"
    },
    id: "elfnhqi7z1ba5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.1 183c-.28 0-.47-.18-.43-.34s.31-.28.59-.25.48.18.43.34-.31.31-.59.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "223.181px 182.709px"
    },
    id: "elkwuemu0zcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11 181.93a.77.77 0 0 1-.7-.13c-.13-.15 0-.33.23-.41a.76.76 0 0 1 .69.13c.13.15.03.33-.22.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "222.873px 181.661px"
    },
    id: "elx2dq86oi4bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 181a.72.72 0 0 1-.7.13c-.25-.07-.36-.25-.23-.4a.72.72 0 0 1 .7-.13c.23.1.35.28.23.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "221.531px 180.865px"
    },
    id: "el8kfgw5jpthq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17 180.69c0 .16-.15.31-.43.34s-.55-.09-.59-.25.14-.32.43-.34.54.08.59.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "219.657px 180.736px"
    },
    id: "elpuxfn1klaqn",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-2",
    className: "animable",
    style: {
      transformOrigin: "299.645px 218.45px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m353.61 234.75-27.54 16a3.22 3.22 0 0 1-2.93 0l-77.46-44.66a.9.9 0 0 1 0-1.7l27.53-16a3.24 3.24 0 0 1 2.94 0l77.46 44.66a.9.9 0 0 1 0 1.7Z",
    style: {
      opacity: 0.2,
      transformOrigin: "299.645px 219.57px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-2",
    className: "animable",
    style: {
      transformOrigin: "299.515px 216.98px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.79 201.14a1 1 0 0 1 .61-.84l24.51-14.15a3.22 3.22 0 0 1 2.93 0l74.79 43.25a1 1 0 0 1 .61.85v2.57a1 1 0 0 1-.61.84l-24.5 14.15a3.22 3.22 0 0 1-2.93 0l-74.8-43.19a1 1 0 0 1-.61-.84Z",
    style: {
      fill: "#263238",
      transformOrigin: "299.515px 216.98px"
    },
    id: "elolh4r6azzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.13 245.18 24.5-14.09a.89.89 0 0 0 0-1.69l-74.79-43.25a3.22 3.22 0 0 0-2.93 0L248.4 200.3a.89.89 0 0 0 0 1.69l74.8 43.18a3.25 3.25 0 0 0 2.93.01Z",
    style: {
      fill: "#37474f",
      transformOrigin: "299.515px 215.661px"
    },
    id: "el58hkrk9vrj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76 245.52v2.63a3 3 0 0 0 1.38-.34l24.49-14.14a1 1 0 0 0 .6-.85v-2.58a1 1 0 0 1-.6.85l-24.49 14.09a3.09 3.09 0 0 1-1.38.34Z",
    style: {
      fill: "#263238",
      transformOrigin: "337.995px 239.195px"
    },
    id: "elqlbarx9t5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.33 201.33 2.43-1.4 3.29 1.9-2.44 1.45-3.29-1.9Zm3.8-2.19 2.42-1.4 2.59 1.49-2.44 1.45-2.58-1.49Zm.8 4.85 2.43-1.41 2.58 1.5-2.44 1.44-2.56-1.52Zm3-7 2.42-1.4 4.18 2.42-2.44 1.44-4.16-2.45Zm.09 4.44 2.43-1.4 2 1.19-2.44 1.45-2.01-1.27Zm.8 4.84 2.42-1.4 2.59 1.49-2.44 1.45-2.58-1.49Zm2.56-2.9 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19Zm.35-8.58 2.43-1.4 3.29 1.9-2.45 1.38-3.29-1.9Zm1 13.73 2.43-1.4 18.67 10.78-2.44 1.45-18.67-10.85Zm.7-8.37 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm1.33 5.16 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19Zm.79-12.71 2.43-1.4 2 1.18-2.44 1.45-2.05-1.18Zm.8 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2 1.19-2.44 1.44-2.05-1.18Zm1.33 5.16 2.43-1.4 2.05 1.15-2.44 1.45-2.05-1.19Zm.79-12.71 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.8 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.26Zm0-14.09 2.43-1.4 2.58 1.49-2.44 1.45-2.58-1.49Zm1.33 19.25 2.43-1.4 2 1.19-2.44 1.45-2-1.19Zm.79-12.71 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.8 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.2Zm1.33 5.16 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19Zm.67-18.1 2.43-1.4 2.05 1.18-2.44 1.45-2.06-1.26Zm.11 5.39 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.81 4.85 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm1.33 5.16 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.31Zm.67-18.1 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.11 5.39 2.43-1.4 2 1.19-2.41 1.37-2-1.18Zm.81 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2 1.19-2.39 1.36-2-1.18Zm1.33 5.16 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.25Zm.67-18.1 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.12 5.39 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.35 17.7 2.42-1.41 2.58 1.5-2.44 1.45-2.56-1.54Zm.43-12.91 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.42 1.48-2.05-1.18Zm1.33 5.16 2.43-1.4 2 1.19-2.33 1.43-2-1.19Zm.67-18.1 2.43-1.4 2.05 1.18-2.43 1.43-2.05-1.18Zm.12 5.39 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.8 4.85 2.43-1.4 2.08 1.17-2.44 1.45-2.05-1.18Zm.1 13.21 2.42-1.4 2.59 1.49-2.45 1.45-2.58-1.49Zm.34-8.57 2.43-1.4 2.05 1.19-2.41 1.43-2.05-1.18Zm1.33 5.16 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19Zm.79-12.71 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.8 4.85 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.1-14 2.42-1.4 2.06 1.19-2.45 1.45-2.05-1.19Zm.09 22.92 2.42-1.4 2.59 1.49-2.43 1.38-2.58-1.49Zm1.14-3.73 2.43-1.4 2.05 1.19-2.42 1.41-2.05-1.19Zm.79-12.7 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.8 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.04-1.18Zm.44 4.64 2.43-1.4 2 1.19-2.44 1.44-2-1.18Zm.1-14 2.42-1.4 2.06 1.19-2.45 1.45-2.05-1.19Zm.62 23.23 2.42-1.41 3.29 1.9-2.44 1.45-3.29-1.9Zm.61-4 2.43-1.4 6.49 3.58-2.44 1.45-6.46-3.71Zm.79-12.71 2.43-1.4 2.05 1.19-2.44 1.44-2.04-1.34Zm.8 4.85 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44 4.64 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.3Zm.1-14 2.42-1.4 2.06 1.19-2.45 1.45-2.05-1.19Zm2 6.48 2.43-1.4 2.05 1.19-2.44 1.44-2.02-1.31Zm.54 17.86 2.43-1.4 2.05 1.18-2.4 1.28-2.05-1.18Zm.26-13 2.43-1.4 2.05 1.18L304 218l-2.05-1.18Zm.44 4.64 2.43-1.4 1.87 1.08a1.23 1.23 0 0 0 .59.12 1.39 1.39 0 0 0 .63-.12l3.18-1.84 2.41 1.39-6.24 3.64-4.88-2.82Zm.1-14 2.42-1.4 2.06 1.19-2.45 1.45-2-1.19Zm2 6.49 2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.55 17.86 2.43-1.4 2 1.18-2.34 1.29-2-1.18Zm.25-13 2.42-1.4 2 1.18-2.33 1.29-2-1.18Zm2-8.55 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.56 5.64 2.43-1.4 2 1.19-2.34 1.19-2-1.18Zm.54 17.86 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.44-4.13 2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19Zm1.82-17.43 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.56 5.64 2.43-1.4 3.65 2.1-2.45 1.45-3.64-2.1Zm1.25 18.27 2.43-1.4 5.41 3.12-2.44 1.45-5.41-3.12Zm.61-12.81 2.42-1.4 2.06 1.19-2.44 1.44-2.06-1.18Zm.94-9.16 2.43-1.4 2.05 1.18-2.44 1.45-2.01-1.39Zm2.25 19.78 2.42-1.4 2.06 1.19-2.44 1.45-2.05-1.19Zm.17-8.68 2.42-1.4 2.06 1.18-2.45 1.45-2.05-1.18Zm.44-4.13 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.5-5 2.43-1.4 2.05 1.18-2.44 1.45-1.99-1.46Zm1.81 23.91 2.43-1.4 2.05 1.18-2.44 1.45-1.99-1.37Zm.44-4.13 2.42-1.4 2.06 1.19-2.38 1.2-2.05-1.19Zm.17-8.68 2.42-1.4 2.06 1.19-2.45 1.44-2-1.18Zm.27 4.54 2.42-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.17-8.67 2.43-1.4 2.05 1.18-2.44 1.45-2-1.18Zm1.25-4.6 2.43-1.4 2.05 1.18-2.44 1.45-2-1.18Zm1.06 23.48 6.22-3.6 2.06 1.19-6.24 3.64-2.05-1.18Zm.44-4.13 2.42-1.4 2.06 1.19-2.42 1.2-2-1.19Zm.44-4.14 2.42-1.4 2.05 1.19-2.44 1.44-2.05-1.18Zm.17-8.67 2.43-1.4 2.05 1.18-2.44 1.45-2-1.37Zm.27 4.54 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm1-9.14 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm1.94 15.21 2.42-1.4 2 1.19-2.44 1.44-2.05-1.18Zm.44-4.13 2.43-1.4 2 1.18-2.44 1.45-2-1.18Zm.43-4.13 2.43-1.4 2 1.18-2.44 1.45-2-1.19Zm.55-5 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm1.94 15.21 6.22-3.59 2.05 1.18-6.23 3.65-2.06-1.19Zm.44-4.13 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm.43-4.13 2.43-1.4 2.05 1.18-2.44 1.45-2.03-1.44Zm2.23-5.17 1-.61 2 1.19-1 .65-2.05-1.18Zm1.13 7.11 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.19Zm2.25-5.38 1-.61 2.05 1.19-1.05.65-2-1.18Zm1.13 7.11 2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18Zm2.23-5.17 1-.61 2.05 1.19-1.05.65L340 228Zm3.36 1.94 1-.61 2.05 1.19-1.05.65-2.05-1.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "299.345px 215.925px"
    },
    id: "elo0is4vv7qei",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "363.92px 141.372px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m417.4 235.75 15.92-9.18c2.39-1.39 2.39-3.62 0-5L319.1 155.62a9.57 9.57 0 0 0-8.66 0l-15.92 9.19c-2.39 1.38-2.39 3.62 0 5l114.22 65.94a9.51 9.51 0 0 0 8.66 0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "363.92px 195.689px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "357.801px 136.502px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.49 215.16 325.94 205c-1.81-1-2.71-2.41-2.71-3.78v-2.44l16.51-9.37a3.85 3.85 0 0 0 1.75-3v-21.65l30.64 17.71v21.63a3.87 3.87 0 0 1-1.74 3l-13.79 8a14.47 14.47 0 0 1-13.11.06Z",
    style: {
      fill: "#37474f",
      transformOrigin: "347.68px 190.73px"
    },
    id: "elc8l6o636ouv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.77 207.93v2.43l5.61-3.23a3.88 3.88 0 0 0 1.75-3v-21.66l-5.84-3.37c-.12 1.49-.25 3-.37 4.51L370 186v16.9a3.87 3.87 0 0 1-1.74 3Z",
    style: {
      fill: "#263238",
      transformOrigin: "368.45px 194.73px"
    },
    id: "el9vgm4v0i6jp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 202.89a3.85 3.85 0 0 1-1.75 3l-11.67 6.81a14.47 14.47 0 0 1-13.1 0l-17.55-10.14c-3.62-2.09-3.62-5.48 0-7.57l11.69-6.81a3.87 3.87 0 0 0 1.74-3v-16.91L370 186Z",
    style: {
      fill: "#455a64",
      transformOrigin: "346.607px 191.269px"
    },
    id: "el9fuyuib0c0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.06 190.26 3.56-2.06a3.87 3.87 0 0 0 1.74-3v-16.93L370 186v16.91a3.85 3.85 0 0 1-1.75 3l-3.49 2Z",
    style: {
      fill: "#37474f",
      transformOrigin: "352.03px 188.09px"
    },
    id: "ellplesxrkbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.22 226.22a4.65 4.65 0 0 1-4.23-.08l-118.52-68.42a4.82 4.82 0 0 1-2.18-3.78V50.2a4.1 4.1 0 0 1 6.28-3.62L419.08 115a4.82 4.82 0 0 1 2.18 3.78v103.74a4.67 4.67 0 0 1-2.04 3.7Z",
    style: {
      fill: "#37474f",
      transformOrigin: "357.774px 136.32px"
    },
    id: "elnl81u08mhho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415 226.14-118.53-68.42a4.82 4.82 0 0 1-2.18-3.78V50.2c0-1.39 1-2 2.18-1.26L415 117.36a4.83 4.83 0 0 1 2.19 3.79v103.73c-.02 1.39-1 1.96-2.19 1.26Z",
    style: {
      fill: "#455a64",
      transformOrigin: "355.74px 137.531px"
    },
    id: "elo58v4as2w3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.07 212.1v-89.59a2.86 2.86 0 0 0-1.31-2.27L299.69 55.53c-.72-.41-1.31-.07-1.31.76v89.59a2.9 2.9 0 0 0 1.31 2.27l112.07 64.7c.73.42 1.31.08 1.31-.75Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "355.725px 134.193px"
    },
    id: "elygbmeqylvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.29 182.43a4.55 4.55 0 0 1 2 3.55c0 1.31-.91 1.84-2 1.18a4.5 4.5 0 0 1-2.05-3.54c0-1.31.92-1.84 2.05-1.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "353.265px 184.798px"
    },
    id: "eljgif4gw3l4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.62 116.63-4.09 2.37a4.63 4.63 0 0 1 .64 2.15v104c0 1.27-.81 1.85-1.86 1.42a4.08 4.08 0 0 0 6-3.79v-104a4.54 4.54 0 0 0-.69-2.15Z",
    style: {
      fill: "#263238",
      transformOrigin: "418.312px 171.841px"
    },
    id: "el7t2fi1o43c6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2",
    className: "animable",
    style: {
      transformOrigin: "352.845px 137.415px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.48 106.53c.15.39.32.8.5 1.23a9.35 9.35 0 0 0 .66 1.3 8.87 8.87 0 0 0 .93 1.26 5.46 5.46 0 0 0 1.29 1 3.44 3.44 0 0 0 1.29.47 1.73 1.73 0 0 0 1.09-.19 1.68 1.68 0 0 0 .76-.9 4.49 4.49 0 0 0 .27-1.72 6.66 6.66 0 0 0-.85-3.25 6.14 6.14 0 0 0-2.33-2.41 2.1 2.1 0 0 0-.85-.29 3.79 3.79 0 0 0-.75 0l-.62.06a.83.83 0 0 1-.49-.08l-5-2.9a1.67 1.67 0 0 1-.64-.77 2.1 2.1 0 0 1-.23-1.07l1-17.14a1.26 1.26 0 0 1 .27-.79.44.44 0 0 1 .6-.05l13.78 8a1.59 1.59 0 0 1 .61.75 2.53 2.53 0 0 1 .26 1.09v5.25a1 1 0 0 1-.26.79.47.47 0 0 1-.61 0l-9.37-5.41-.23 4.28a3.27 3.27 0 0 1 1.34 0 4.9 4.9 0 0 1 1.66.64 15.26 15.26 0 0 1 3.44 2.78 19.3 19.3 0 0 1 2.77 3.88 20.75 20.75 0 0 1 1.83 4.73 21.51 21.51 0 0 1 .66 5.39 13.59 13.59 0 0 1-.72 4.83 5.45 5.45 0 0 1-2 2.69 4.45 4.45 0 0 1-3 .64 9.56 9.56 0 0 1-3.67-1.33 16.62 16.62 0 0 1-3.91-3.13 20.09 20.09 0 0 1-2.91-4 20.46 20.46 0 0 1-1.84-4.43 17.27 17.27 0 0 1-.68-4.33.92.92 0 0 1 .21-.65.39.39 0 0 1 .5 0l4.09 2.36a2.12 2.12 0 0 1 .79.75 5 5 0 0 1 .36.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "330.898px 100.43px"
    },
    id: "el4dcujg5gllh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.53 96.11a15.21 15.21 0 0 1 4.15 3.49 20.55 20.55 0 0 1 2.89 4.59 23.88 23.88 0 0 1 1.7 5.27 32.73 32.73 0 0 1 .66 5.51c.05 1.45.07 3 .07 4.5s0 3-.07 4.32a21.18 21.18 0 0 1-.66 4.75 7.35 7.35 0 0 1-1.7 3.31 4.21 4.21 0 0 1-2.89 1.26 7.84 7.84 0 0 1-4.15-1.31 15.21 15.21 0 0 1-4.15-3.49 20.16 20.16 0 0 1-2.88-4.59 23.38 23.38 0 0 1-1.71-5.27 32.73 32.73 0 0 1-.66-5.51c0-1.38-.06-2.85-.06-4.4s0-3 .06-4.43a21.27 21.27 0 0 1 .66-4.75 7.27 7.27 0 0 1 1.71-3.3 4.17 4.17 0 0 1 2.88-1.26 7.84 7.84 0 0 1 4.15 1.31Zm3.45 24q.12-4.14 0-8.33c-.05-.85-.13-1.66-.25-2.42a9.51 9.51 0 0 0-.56-2.13 7 7 0 0 0-1-1.81 5.41 5.41 0 0 0-1.61-1.38 2.76 2.76 0 0 0-1.61-.48 1.4 1.4 0 0 0-1 .62 3.86 3.86 0 0 0-.58 1.47 12.07 12.07 0 0 0-.22 2.15q-.16 4 0 8.33a20.08 20.08 0 0 0 .2 2.4 10.19 10.19 0 0 0 .58 2.14 7.27 7.27 0 0 0 1.05 1.82 5.53 5.53 0 0 0 1.61 1.38 2.78 2.78 0 0 0 1.61.48 1.48 1.48 0 0 0 1.05-.61 3.56 3.56 0 0 0 .58-1.47 14.64 14.64 0 0 0 .17-2.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "352.535px 113.955px"
    },
    id: "el8g53l6pyea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 113.59a1.68 1.68 0 0 1 .61.76 2.53 2.53 0 0 1 .26 1.09v5.25a1.46 1.46 0 0 1-.23.86 3.32 3.32 0 0 1-.42.5l-3.89 3.8a20.3 20.3 0 0 1 4.09 5.71 16.16 16.16 0 0 1 1.58 7.13c0 3.74-.84 6.06-2.52 7s-4 .51-7-1.23a18 18 0 0 1-4.11-3.21 21.1 21.1 0 0 1-3-4 20 20 0 0 1-1.88-4.24 14.34 14.34 0 0 1-.7-4 .88.88 0 0 1 .21-.65.39.39 0 0 1 .5 0l4.06 2.34a2.65 2.65 0 0 1 1 1.07c.23.45.5.94.79 1.47a12.49 12.49 0 0 0 1.12 1.67 7.12 7.12 0 0 0 2 1.61 3.81 3.81 0 0 0 2.55.68c.68-.13 1-.78 1-1.94a5.11 5.11 0 0 0-1-3.11 8.2 8.2 0 0 0-2.55-2.27l-2.68-1.55a1.59 1.59 0 0 1-.61-.75 2.53 2.53 0 0 1-.26-1.09v-4.26a1.46 1.46 0 0 1 .23-.86 3.55 3.55 0 0 1 .45-.53l3.41-3.34-8.4-4.85a1.63 1.63 0 0 1-.61-.75 2.42 2.42 0 0 1-.26-1.09v-5.25a1 1 0 0 1 .26-.8.47.47 0 0 1 .61 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "374.394px 125.412px"
    },
    id: "el8b05vrdztyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.06 140.4a.6.6 0 0 1 .23.28.88.88 0 0 1 .1.41v2a.37.37 0 0 1-.1.29.18.18 0 0 1-.23 0l-5.68-3.29a.55.55 0 0 1-.23-.28 1 1 0 0 1-.1-.4v-11.95a.41.41 0 0 1 .1-.3.18.18 0 0 1 .23 0l5.59 3.23a.67.67 0 0 1 .23.28 1 1 0 0 1 .09.41v2a.4.4 0 0 1-.09.29.18.18 0 0 1-.23 0l-3.7-2.14v2l3.43 2a.55.55 0 0 1 .23.28.86.86 0 0 1 .1.41v1.95a.38.38 0 0 1-.1.3.18.18 0 0 1-.23 0l-3.43-2v2.07Z",
    style: {
      fill: "#455a64",
      transformOrigin: "336.22px 135.27px"
    },
    id: "el8xj28dw8wty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34 133.48a6.87 6.87 0 0 1 1.42 1.07 6.24 6.24 0 0 1 1.06 1.39 6.49 6.49 0 0 1 .67 1.71 8 8 0 0 1 .24 2 4.66 4.66 0 0 1-.37 2.08 1.37 1.37 0 0 1-1.06.79l1.49 5.25a1.11 1.11 0 0 1 0 .23.29.29 0 0 1-.08.24.14.14 0 0 1-.18 0l-1.63-.94a.74.74 0 0 1-.34-.36 3.46 3.46 0 0 1-.17-.43l-1.33-4.72-1.1-.64v4a.38.38 0 0 1-.1.3.18.18 0 0 1-.23 0l-1.57-.91a.67.67 0 0 1-.23-.28 1 1 0 0 1-.09-.41v-11.94a.43.43 0 0 1 .09-.3.18.18 0 0 1 .23 0Zm-1.34 4.81 1.35.78a1.07 1.07 0 0 0 .84.19c.22-.07.33-.37.33-.88a2.24 2.24 0 0 0-.33-1.27 2.48 2.48 0 0 0-.84-.77l-1.35-.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "344.267px 139.921px"
    },
    id: "elbsd6kqud9mn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68 138.29a6.47 6.47 0 0 1 2.48 2.46 6.77 6.77 0 0 1 .67 1.71 8.14 8.14 0 0 1 .24 2 4.55 4.55 0 0 1-.38 2.09 1.35 1.35 0 0 1-1.05.78l1.49 5.26a1 1 0 0 1 0 .22.29.29 0 0 1-.08.24.14.14 0 0 1-.18 0l-1.63-1a.81.81 0 0 1-.35-.36c-.06-.15-.12-.29-.16-.43l-1.33-4.72-1.1-.64v4a.4.4 0 0 1-.1.29.18.18 0 0 1-.23 0l-1.57-.91a.61.61 0 0 1-.23-.28 1 1 0 0 1-.09-.4v-11.88a.4.4 0 0 1 .09-.29.18.18 0 0 1 .23 0Zm-1.35 4.81 1.35.79a1.09 1.09 0 0 0 .84.18c.22-.07.33-.36.33-.88a2.18 2.18 0 0 0-.33-1.26 2.61 2.61 0 0 0-.84-.78l-1.35-.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "352.607px 144.736px"
    },
    id: "el7xmikm4cbqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17 145.7a6.19 6.19 0 0 1 .29-1.78 2.53 2.53 0 0 1 .74-1.16 1.7 1.7 0 0 1 1.15-.41 3.23 3.23 0 0 1 1.56.51 5.84 5.84 0 0 1 1.56 1.29 8.51 8.51 0 0 1 1.16 1.74 9.47 9.47 0 0 1 .73 2 11.16 11.16 0 0 1 .3 2.12v3.29a6.54 6.54 0 0 1-.3 1.78 2.62 2.62 0 0 1-.73 1.18 1.72 1.72 0 0 1-1.16.4 3.46 3.46 0 0 1-1.56-.51 6.28 6.28 0 0 1-1.56-1.3 7.89 7.89 0 0 1-1.15-1.73 10 10 0 0 1-.74-2 10.39 10.39 0 0 1-.29-2.12v-1.64c0-.58-.02-1.14 0-1.66Zm5.27 6.24v-3.11a5.66 5.66 0 0 0-.13-.92 3.79 3.79 0 0 0-.29-.84 3.39 3.39 0 0 0-.46-.72 2.26 2.26 0 0 0-.65-.54 1.36 1.36 0 0 0-.64-.21.71.71 0 0 0-.47.19 1.13 1.13 0 0 0-.28.51 2.87 2.87 0 0 0-.13.77V150.18a5 5 0 0 0 .41 1.77 2.71 2.71 0 0 0 1.11 1.25q.75.44 1.11 0a2.14 2.14 0 0 0 .42-1.26Z",
    style: {
      fill: "#455a64",
      transformOrigin: "360.911px 149.505px"
    },
    id: "els2ph44fs9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63 148.08a6.87 6.87 0 0 1 1.42 1.07 6.47 6.47 0 0 1 1.73 3.1 8.14 8.14 0 0 1 .24 2 4.74 4.74 0 0 1-.37 2.09 1.37 1.37 0 0 1-1.06.78l1.49 5.26a1 1 0 0 1 0 .22.33.33 0 0 1-.07.24.15.15 0 0 1-.19 0l-1.63-.94a.74.74 0 0 1-.34-.36 2.94 2.94 0 0 1-.17-.43l-1.33-4.72-1.1-.64v4a.37.37 0 0 1-.1.29.18.18 0 0 1-.23 0l-1.57-.91a.54.54 0 0 1-.22-.28.86.86 0 0 1-.1-.41v-11.93a.37.37 0 0 1 .1-.29c.06-.07.13-.07.22 0Zm-1.35 4.81 1.35.78a1.07 1.07 0 0 0 .84.19c.22-.07.33-.36.33-.88a2.18 2.18 0 0 0-.33-1.26 2.41 2.41 0 0 0-.84-.78l-1.35-.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "369.557px 154.521px"
    },
    id: "eljnjjq5cum7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.86 133.32a3.27 3.27 0 0 1 .92.78 6.31 6.31 0 0 1 .68 1 5.37 5.37 0 0 1 .42 1 3.56 3.56 0 0 1 .16.84.25.25 0 0 1-.05.17.11.11 0 0 1-.14 0l-.35-.2a.41.41 0 0 1-.15-.14 1.1 1.1 0 0 1-.12-.31 4 4 0 0 0-.14-.41 3.87 3.87 0 0 0-.26-.55 4.05 4.05 0 0 0-.41-.57 2.22 2.22 0 0 0-.56-.45 1.18 1.18 0 0 0-.45-.18.63.63 0 0 0-.39 0 .56.56 0 0 0-.28.27 1.3 1.3 0 0 0-.1.54 1.81 1.81 0 0 0 .1.63 2.4 2.4 0 0 0 .32.61 4.51 4.51 0 0 0 .55.67c.22.24.49.51.81.83a8.1 8.1 0 0 1 .82.91 5.64 5.64 0 0 1 .56.85 4 4 0 0 1 .31.86 4.75 4.75 0 0 1 .1.94 2.62 2.62 0 0 1-.17 1 1.25 1.25 0 0 1-.47.58 1.13 1.13 0 0 1-.72.13 2.43 2.43 0 0 1-.94-.35 3.79 3.79 0 0 1-.92-.75 5.68 5.68 0 0 1-.72-1 5.91 5.91 0 0 1-.47-1.07 3 3 0 0 1-.18-1 .22.22 0 0 1 .05-.17.09.09 0 0 1 .13 0l.35.2a.5.5 0 0 1 .15.14.71.71 0 0 1 .12.31 3.91 3.91 0 0 0 .16.49 3.33 3.33 0 0 0 .28.57 3.86 3.86 0 0 0 .44.58 2.7 2.7 0 0 0 .61.48 1.85 1.85 0 0 0 .57.22.75.75 0 0 0 .47 0 .58.58 0 0 0 .32-.28 1 1 0 0 0 .13-.55 1.75 1.75 0 0 0-.14-.67 3 3 0 0 0-.4-.67 7.51 7.51 0 0 0-.62-.72l-.85-.84a6 6 0 0 1-.72-.83 5.22 5.22 0 0 1-.49-.84 3.49 3.49 0 0 1-.27-.85 5.14 5.14 0 0 1-.08-.88 2.57 2.57 0 0 1 .13-.87 1.22 1.22 0 0 1 .38-.6 1 1 0 0 1 .66-.17 1.8 1.8 0 0 1 .86.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "308.915px 138.064px"
    },
    id: "ely13gi7k7le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 145.6a.48.48 0 0 1 .16.2.77.77 0 0 1 .07.29v.47a.29.29 0 0 1-.07.21.11.11 0 0 1-.16 0l-3.46-2a.42.42 0 0 1-.16-.2.62.62 0 0 1-.07-.29v-8.5a.25.25 0 0 1 .07-.21.12.12 0 0 1 .16 0l3.39 2a.48.48 0 0 1 .16.2.77.77 0 0 1 .07.29v.47a.29.29 0 0 1-.07.21.11.11 0 0 1-.16 0l-2.81-1.61v2.77l2.62 1.51a.47.47 0 0 1 .16.2.65.65 0 0 1 .07.29v.48a.28.28 0 0 1-.07.21.12.12 0 0 1-.16 0l-2.62-1.51v2.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "314.269px 141.172px"
    },
    id: "elkier5018g4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 139.69a3.78 3.78 0 0 1 .79.62 4.08 4.08 0 0 1 .66.86 4.72 4.72 0 0 1 .61 2.44 2.47 2.47 0 0 1-.34 1.5 1 1 0 0 1-.89.38l1.29 4.21a.5.5 0 0 1 0 .16.22.22 0 0 1-.06.17.1.1 0 0 1-.13 0l-.37-.21a.62.62 0 0 1-.25-.28l-.12-.29-1.24-4.07-1.47-.85v3.35a.29.29 0 0 1-.06.21.12.12 0 0 1-.17 0l-.35-.2a.43.43 0 0 1-.16-.2.59.59 0 0 1-.07-.29v-8.5a.25.25 0 0 1 .07-.21.11.11 0 0 1 .16 0Zm-1.49 3.46 1.45.83c.41.24.73.3.95.18s.34-.46.34-1a2.56 2.56 0 0 0-.34-1.39 2.66 2.66 0 0 0-.95-.9l-1.45-.83Z",
    style: {
      fill: "#455a64",
      transformOrigin: "319.567px 144.255px"
    },
    id: "elwv8rhki0ja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43 143.92a.37.37 0 0 1 .09-.16h.24l.32.19a.36.36 0 0 1 .13.16.53.53 0 0 1 .06.24.5.5 0 0 1 0 .12l-1.85 7.2a.44.44 0 0 1-.16.28.24.24 0 0 1-.29 0l-.34-.19a.79.79 0 0 1-.29-.31 2.08 2.08 0 0 1-.16-.48l-1.85-9.34a.34.34 0 0 1 0-.14.26.26 0 0 1 0-.17.11.11 0 0 1 .14 0l.31.18a.52.52 0 0 1 .24.25 1.61 1.61 0 0 1 .1.28l1.65 8.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "324.795px 146.647px"
    },
    id: "ell8a5rc83at8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51 154a.43.43 0 0 1-.16-.2.73.73 0 0 1-.07-.29V145a.29.29 0 0 1 .07-.21.11.11 0 0 1 .16 0l.35.2a.39.39 0 0 1 .17.2.72.72 0 0 1 .06.29V154a.29.29 0 0 1-.06.21.12.12 0 0 1-.17 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "328.686px 149.5px"
    },
    id: "elmdj5fzqtg2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.15 149.82v2.21a5.34 5.34 0 0 0 .44 2 2.92 2.92 0 0 0 1.16 1.35 1.61 1.61 0 0 0 .7.24.7.7 0 0 0 .46-.14.82.82 0 0 0 .28-.41 2.65 2.65 0 0 0 .15-.57c0-.09 0-.14.09-.16a.17.17 0 0 1 .14 0l.39.23a.31.31 0 0 1 .13.16.53.53 0 0 1 .06.24 3.31 3.31 0 0 1-.15.86 1.82 1.82 0 0 1-.42.73 1.18 1.18 0 0 1-.74.33 1.89 1.89 0 0 1-1.09-.33 3.57 3.57 0 0 1-1-.84 5.65 5.65 0 0 1-.75-1.18 7.44 7.44 0 0 1-.48-1.4 7.82 7.82 0 0 1-.19-1.54v-2.34a5 5 0 0 1 .19-1.31 2.07 2.07 0 0 1 .48-.86 1.15 1.15 0 0 1 .75-.31 1.92 1.92 0 0 1 1 .3 3.8 3.8 0 0 1 1.09.94 5.42 5.42 0 0 1 .74 1.18 6 6 0 0 1 .42 1.21 5.55 5.55 0 0 1 .15 1 .21.21 0 0 1-.06.17.09.09 0 0 1-.13 0l-.39-.23a.34.34 0 0 1-.14-.15.67.67 0 0 1-.09-.26 5.11 5.11 0 0 0-.15-.74 3 3 0 0 0-.28-.74 3.63 3.63 0 0 0-.46-.67 2.62 2.62 0 0 0-.7-.56c-.5-.29-.89-.29-1.16 0a2.37 2.37 0 0 0-.44 1.59Z",
    style: {
      fill: "#455a64",
      transformOrigin: "332.741px 151.835px"
    },
    id: "elgo0jyiyfiw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 159.43a.43.43 0 0 1 .17.2.77.77 0 0 1 .07.29v.47a.34.34 0 0 1-.07.22.15.15 0 0 1-.17 0l-3.45-2a.37.37 0 0 1-.16-.2.59.59 0 0 1-.07-.29v-8.5a.25.25 0 0 1 .07-.21.11.11 0 0 1 .16 0l3.39 2a.48.48 0 0 1 .16.2.77.77 0 0 1 .07.29v.47a.29.29 0 0 1-.07.21.12.12 0 0 1-.16 0l-2.81-1.62v2.78l2.62 1.51a.43.43 0 0 1 .16.2.58.58 0 0 1 .07.28v.48a.27.27 0 0 1-.07.21.12.12 0 0 1-.16 0l-2.62-1.51v2.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "338.279px 155.006px"
    },
    id: "elsmojeikj79j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74 155.89a.56.56 0 0 1 .16.2.82.82 0 0 1 .07.29v5.27a6.56 6.56 0 0 1-.14 1.42 2.21 2.21 0 0 1-.41.94.94.94 0 0 1-.71.36 1.92 1.92 0 0 1-1-.32 3.67 3.67 0 0 1-1.06-.89 4.87 4.87 0 0 1-.71-1.19 6.39 6.39 0 0 1-.41-1.41 9.9 9.9 0 0 1-.12-1.57v-5.26a.29.29 0 0 1 .06-.21.13.13 0 0 1 .17 0l.35.21a.43.43 0 0 1 .16.2.73.73 0 0 1 .07.29v5.33a5.15 5.15 0 0 0 .39 2.14 2.69 2.69 0 0 0 1.1 1.26c.46.27.83.27 1.09 0a2.48 2.48 0 0 0 .4-1.69v-5.33a.29.29 0 0 1 .07-.21.11.11 0 0 1 .16 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "345.689px 158.929px"
    },
    id: "eluuo1dhhil9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32 168.33a.45.45 0 0 1-.2-.24 2.13 2.13 0 0 1-.14-.35l-2.78-8v6.48a.33.33 0 0 1-.07.21.13.13 0 0 1-.16 0l-.35-.21a.4.4 0 0 1-.17-.19.82.82 0 0 1-.07-.29v-8.54a.31.31 0 0 1 .07-.21.13.13 0 0 1 .17 0l.29.17a.56.56 0 0 1 .21.24c.05.12.1.24.14.36l2.78 8v-6.48a.29.29 0 0 1 .06-.21.13.13 0 0 1 .17 0l.35.2a.48.48 0 0 1 .16.2.62.62 0 0 1 .07.29v8.5a.25.25 0 0 1-.07.21.12.12 0 0 1-.16 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "351.616px 162.729px"
    },
    id: "elp3tjpohdr3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359 169.52-3-1.72-.44 1.5a.39.39 0 0 1-.1.16s-.12 0-.24 0l-.31-.18a.38.38 0 0 1-.14-.16.69.69 0 0 1 0-.24.55.55 0 0 1 0-.16l2.1-7.1a.71.71 0 0 1 .13-.22c0-.06.14-.06.25 0l.52.29a.62.62 0 0 1 .25.3 2.28 2.28 0 0 1 .13.36l2.09 9.51a1.14 1.14 0 0 1 0 .21.26.26 0 0 1-.05.17.12.12 0 0 1-.14 0l-.31-.19a.45.45 0 0 1-.24-.25 1.3 1.3 0 0 1-.1-.27Zm-2.67-2.73 2.37 1.37-1.18-5.38Z",
    style: {
      fill: "#455a64",
      transformOrigin: "357.502px 166.809px"
    },
    id: "elv9rtcqfxjem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.41 165.85a.42.42 0 0 1 .09-.16c.05-.05.13 0 .24 0l.32.19a.36.36 0 0 1 .13.16.49.49 0 0 1 .06.23.51.51 0 0 1 0 .13l-1.85 7.2a.47.47 0 0 1-.16.28.26.26 0 0 1-.29 0l-.34-.2a.63.63 0 0 1-.28-.3 1.7 1.7 0 0 1-.17-.48l-1.85-9.34a.36.36 0 0 1 0-.14.25.25 0 0 1 .05-.17.11.11 0 0 1 .14 0l.31.18a.52.52 0 0 1 .24.25 1.3 1.3 0 0 1 .1.27l1.65 8.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "362.779px 168.575px"
    },
    id: "eltsj3wbr7fj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.51 175.6-3-1.71-.45 1.49a.56.56 0 0 1-.09.17q-.08.07-.24 0l-.32-.18a.43.43 0 0 1-.13-.16.53.53 0 0 1-.06-.24.45.45 0 0 1 0-.17l2.09-7.09a.61.61 0 0 1 .13-.22c.06-.06.14-.06.26 0l.51.29a.73.73 0 0 1 .26.29 2.25 2.25 0 0 1 .12.37l2.09 9.51a1.36 1.36 0 0 1 0 .2.24.24 0 0 1-.06.18.1.1 0 0 1-.13 0l-.32-.18a.58.58 0 0 1-.24-.25 2.13 2.13 0 0 1-.09-.27Zm-2.67-2.72 2.37 1.36-1.21-5.38Z",
    style: {
      fill: "#455a64",
      transformOrigin: "367.948px 172.899px"
    },
    id: "el3ttdgtjx99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.91 179.06a.4.4 0 0 1-.17-.19.79.79 0 0 1-.06-.29v-8.51a.31.31 0 0 1 .06-.21.13.13 0 0 1 .17 0l.35.2a.48.48 0 0 1 .16.2.62.62 0 0 1 .07.29V179a.29.29 0 0 1-.07.22.13.13 0 0 1-.16 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "372.085px 174.538px"
    },
    id: "eld8reevcw6hp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.67 181.21a.37.37 0 0 1 .16.2.59.59 0 0 1 .07.29v.47a.25.25 0 0 1-.07.21.12.12 0 0 1-.16 0l-3.48-2a.37.37 0 0 1-.16-.2.59.59 0 0 1-.07-.29v-8.5a.25.25 0 0 1 .07-.21.12.12 0 0 1 .16 0l.35.2a.42.42 0 0 1 .16.2.62.62 0 0 1 .07.29v7.67Z",
    style: {
      fill: "#455a64",
      transformOrigin: "375.93px 176.78px"
    },
    id: "elzcjx9xxqkyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.45 183.07-3-1.71-.44 1.49a.42.42 0 0 1-.1.17s-.12 0-.24 0l-.31-.18a.34.34 0 0 1-.13-.17.46.46 0 0 1-.06-.23.61.61 0 0 1 0-.17l2.1-7.09a.61.61 0 0 1 .13-.22c.05-.06.14-.06.25 0l.52.3a.59.59 0 0 1 .25.29 2.05 2.05 0 0 1 .13.37l2.09 9.51a1.06 1.06 0 0 1 0 .2.25.25 0 0 1-.05.17s-.08 0-.14 0l-.31-.18a.52.52 0 0 1-.24-.25 1.3 1.3 0 0 1-.1-.27Zm-2.67-2.72 2.37 1.36-1.15-5.38Z",
    style: {
      fill: "#455a64",
      transformOrigin: "380.904px 180.358px"
    },
    id: "eluot1trzozha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84 186.53a.43.43 0 0 1-.16-.2.59.59 0 0 1-.07-.29v-8.5a.25.25 0 0 1 .07-.21.12.12 0 0 1 .16 0l2.29 1.32a3 3 0 0 1 .91.78 4.65 4.65 0 0 1 .88 2 4.63 4.63 0 0 1 .09.83 2.32 2.32 0 0 1-.09.71 1.29 1.29 0 0 1-.2.44.65.65 0 0 1-.22.22l-.17.09a6.36 6.36 0 0 1 .57 1.23 4.45 4.45 0 0 1 .24 1.45 3.18 3.18 0 0 1-.12.91 1.61 1.61 0 0 1-.35.65.93.93 0 0 1-.59.27 1.43 1.43 0 0 1-.82-.24Zm.58-7.69v2.66l1.63.94c.38.22.67.27.86.15s.28-.39.28-.82a2.34 2.34 0 0 0-.28-1.16 2.29 2.29 0 0 0-.86-.83Zm0 3.84v3l1.75 1a1.21 1.21 0 0 0 .51.18.56.56 0 0 0 .36-.12.78.78 0 0 0 .22-.35 1.66 1.66 0 0 0 .07-.53 2.58 2.58 0 0 0-.07-.6 2.32 2.32 0 0 0-.21-.61 2.12 2.12 0 0 0-.36-.54 2 2 0 0 0-.52-.43Z",
    style: {
      fill: "#455a64",
      transformOrigin: "386.874px 182.765px"
    },
    id: "el93nr856yssg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 190.65a.48.48 0 0 1 .16.2.77.77 0 0 1 .07.29v.47a.29.29 0 0 1-.07.21.12.12 0 0 1-.16 0l-3.48-2a.49.49 0 0 1-.17-.2.79.79 0 0 1-.06-.29v-8.51a.33.33 0 0 1 .06-.21.13.13 0 0 1 .17 0l.35.2a.56.56 0 0 1 .16.2.65.65 0 0 1 .07.29v7.7Z",
    style: {
      fill: "#455a64",
      transformOrigin: "392.26px 186.214px"
    },
    id: "elhx0benv2ecf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84 193.43a.42.42 0 0 1 .16.2.62.62 0 0 1 .07.29v.47a.25.25 0 0 1-.07.21.11.11 0 0 1-.16 0l-3.45-2a.43.43 0 0 1-.17-.2.77.77 0 0 1-.07-.29v-8.5a.29.29 0 0 1 .07-.21.13.13 0 0 1 .17 0l3.38 2a.42.42 0 0 1 .16.2.62.62 0 0 1 .07.29v.47a.25.25 0 0 1-.07.21.11.11 0 0 1-.16 0l-2.8-1.61v2.77l2.61 1.51a.49.49 0 0 1 .17.2.82.82 0 0 1 .07.29v.48a.33.33 0 0 1-.07.21.13.13 0 0 1-.17 0l-2.58-1.53v2.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "397.111px 189.001px"
    },
    id: "elr083xg69mc8",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-2",
    className: "animable",
    style: {
      transformOrigin: "367.3px 248.839px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m349.71 254.34 9.43 5.44a10.36 10.36 0 0 0 10.4-.55l15.54-11.35c2.78-2 2.62-5-.35-6.76l-4.73-2.74a12.81 12.81 0 0 0-10.92-.33l-19.19 10.4c-3.07 1.55-3.15 4.18-.18 5.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "367.3px 248.954px"
    },
    className: "animable",
    id: "el8nsw9tzmjmi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.34 243-10.76 8.41-7.93 6.21a7.32 7.32 0 0 1-6.3-.19l-8.43-4.86a6 6 0 0 1-1.71-8.54l.25-.34a11.22 11.22 0 0 1 6.78-4.3l4.28-.86c6.91-1.4 12.59-2.08 13.25-1.64l10.57 6.13Z",
    style: {
      fill: "#37474f",
      transformOrigin: "367.226px 247.499px"
    },
    id: "el1xlvc20erqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.33 247.66.6-.48-9.48-5.47 8.3-2.57-.84-.49-8.3 2.57L364 238l-1.07.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "371.43px 242.83px"
    },
    id: "elu5a5rn0kg4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58 257.06h.05l7.55-5.45 10.2-7.37V243a.1.1 0 0 0-.05-.09h-.06c-.76-.26-5.18 1.06-10.52 3.19l-3.54 1.4a11.28 11.28 0 0 0-7.1 10.5v.19a7 7 0 0 0 2.54-.61Z",
    style: {
      fill: "#263238",
      transformOrigin: "374.745px 250.534px"
    },
    id: "ellg26lfwa8lj",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-2",
    className: "animable",
    style: {
      transformOrigin: "105.445px 273.803px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-2",
    className: "animable",
    style: {
      transformOrigin: "105.445px 273.803px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "96.14px 211.78px"
    },
    id: "el8ksj9d4jjtc",
    className: "animable",
    d: "m100.74 239.65-5.03.14-4.17-55.87 5.02-.15 4.18 55.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "53.16px 235.37px"
    },
    id: "elxgc4gy4lfkm",
    className: "animable",
    d: "m57.76 263.24-5.02.14-4.18-55.87 5.03-.15 4.17 55.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46 268h-8.32L40.8 345.49a1 1 0 0 0 .6.92 3.3 3.3 0 0 0 3 0 1.14 1.14 0 0 0 .59-.72Z",
    style: {
      fill: "#455a64",
      transformOrigin: "50.13px 307.385px"
    },
    id: "el271v4jfgtjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.41 239.19h-8.33L89 325.65a1 1 0 0 0 .61.91 3.22 3.22 0 0 0 3 0 1.09 1.09 0 0 0 .59-.71Z",
    style: {
      fill: "#37474f",
      transformOrigin: "99.205px 283.06px"
    },
    id: "elnom1y1xm80i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73 352.94 159.36 268H151l18.52 85.11a1.09 1.09 0 0 0 .59.71 3.24 3.24 0 0 0 3 0 1 1 0 0 0 .6-.91Z",
    style: {
      fill: "#37474f",
      transformOrigin: "162.365px 311.094px"
    },
    id: "elguxapzotfko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.62 384.18-12.1-86.45h-8.33l16.25 86.65a1.13 1.13 0 0 0 .59.72 3.3 3.3 0 0 0 3 0 1 1 0 0 0 .6-.92Z",
    style: {
      fill: "#455a64",
      transformOrigin: "109.41px 341.595px"
    },
    id: "el9uf2s8298t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.36 268H151l3.39 15.56q2.84-2.35 5.53-4.83a5.38 5.38 0 0 0 1-1.33Z",
    style: {
      fill: "#37474f",
      transformOrigin: "155.96px 275.78px"
    },
    id: "eldxv9gk40rwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.14 268-1.45 10.33a6.69 6.69 0 0 0 1.61 2.81c1.55 1.42 3.19 2.85 4.89 4.28L59.46 268Z",
    style: {
      fill: "#37474f",
      transformOrigin: "54.575px 276.71px"
    },
    id: "el1kauqers4cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.19 309.64-1.67-11.91h-8.33l2.72 14.51c2.48-.83 4.9-1.7 7.28-2.6Z",
    style: {
      fill: "#37474f",
      transformOrigin: "104.19px 304.985px"
    },
    id: "elnjotuqv24j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83 305.69c23.55-7.8 42.59-19.23 58.12-33.51a6.66 6.66 0 0 0 1.87-4.31v-4.49a5.71 5.71 0 0 0-2-4.09c-16.48-12-35.69-20.27-57.86-24.45a12.3 12.3 0 0 0-5 .28q-29.82 9.09-45.78 26.2a7.56 7.56 0 0 0-1.71 4.47v4.49a6.63 6.63 0 0 0 1.87 4.31c11.92 11 29 22.25 45.78 30.75a7.09 7.09 0 0 0 4.71.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "105.645px 270.321px"
    },
    id: "elx61wmxpzzze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.82 263.38v4.49a6.73 6.73 0 0 1-1.87 4.32c-15.53 14.27-34.57 25.71-58.12 33.5a6.62 6.62 0 0 1-2.64.21v-71.16a10.81 10.81 0 0 1 2.72.11c22.16 4.17 41.39 12.42 57.86 24.45a5.67 5.67 0 0 1 2.05 4.08Z",
    style: {
      opacity: 0.4,
      transformOrigin: "130.505px 270.325px"
    },
    className: "animable",
    id: "eldg0baydjddh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19 234.74v71.16a6.29 6.29 0 0 1-2.1-.56c-16.81-8.5-33.86-19.77-45.79-30.74a6.77 6.77 0 0 1-1.86-4.32v-4.5a7.39 7.39 0 0 1 1.72-4.45q15.95-17.12 45.77-26.22a11 11 0 0 1 2.26-.37Z",
    style: {
      opacity: 0.5,
      transformOrigin: "74.315px 270.32px"
    },
    className: "animable",
    id: "elqhbvwz89mim"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31 265c11.92 11 29 22.22 45.78 30.72a7.16 7.16 0 0 0 4.74.35c23.55-7.75 42.59-19.18 58.12-33.45a2.06 2.06 0 0 0-.18-3.28c-16.48-12-35.69-20.27-57.86-24.45a12.3 12.3 0 0 0-5 .28q-29.82 9.09-45.78 26.17a2.6 2.6 0 0 0 .18 3.66Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "105.571px 265.536px"
    },
    id: "el2citc7qb4g2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31 265c11.92 11 29 22.22 45.78 30.72a7.16 7.16 0 0 0 4.74.35c23.55-7.75 42.59-19.18 58.12-33.45a2.06 2.06 0 0 0-.18-3.28c-16.48-12-35.69-20.27-57.86-24.45a12.3 12.3 0 0 0-5 .28q-29.82 9.09-45.78 26.17a2.6 2.6 0 0 0 .18 3.66Z",
    style: {
      opacity: 0.3,
      transformOrigin: "105.571px 265.536px"
    },
    className: "animable",
    id: "elqw48xvkv429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.71 198.27q23.92-30.75 62.51-36.09a8.53 8.53 0 0 1 4.62.88 4.77 4.77 0 0 1 2.08 3.77v18.9a3 3 0 0 1-2.54 2.89Q66.8 194 42.87 224.71a2.91 2.91 0 0 1-3.63.83 4.74 4.74 0 0 1-2.08-3.76v-18.91a8.74 8.74 0 0 1 1.55-4.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "72.54px 194px"
    },
    id: "el1ga1jp7kd25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.67 211-18.09-10.45a8 8 0 0 0-.42 2.32v18.91a4.74 4.74 0 0 0 2.08 3.76 2.91 2.91 0 0 0 3.63-.83A101.12 101.12 0 0 1 55.67 211Z",
    style: {
      opacity: 0.5,
      transformOrigin: "46.415px 213.202px"
    },
    className: "animable",
    id: "elcgcpcth23q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.67 211q20.72-18.36 49.71-22.38a3 3 0 0 0 2.54-2.89v-18.9a4.77 4.77 0 0 0-2.08-3.77 8.53 8.53 0 0 0-4.62-.88q-38.6 5.35-62.51 36.09a7.83 7.83 0 0 0-1.13 2.28Z",
    style: {
      opacity: 0.3,
      transformOrigin: "72.75px 186.572px"
    },
    className: "animable",
    id: "eluztzr8cz6q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.87 224.71Q66.8 194 105.38 188.62a3 3 0 0 0 2.54-2.89v-18.9a2.19 2.19 0 0 0-2.54-2.24q-38.58 5.34-62.51 36.09a8.68 8.68 0 0 0-1.55 4.6v18.9c0 1.42.68 1.64 1.55.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "74.6207px 194.988px"
    },
    id: "elfblsvn13qgc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.87 224.71Q66.8 194 105.38 188.62a3 3 0 0 0 2.54-2.89v-18.9a2.19 2.19 0 0 0-2.54-2.24q-38.58 5.34-62.51 36.09a8.68 8.68 0 0 0-1.55 4.6v18.9c0 1.42.68 1.64 1.55.53Z",
    style: {
      opacity: 0.4,
      transformOrigin: "74.6207px 194.988px"
    },
    className: "animable",
    id: "elpci91h3z6qg"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "109.504px 241.255px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "109.504px 241.255px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.13 319.32s-7.19 15.8-7.77 22.12c-.61 6.59-2.29 8.71-1.45 15.93.18 1.58.87 4.74 1 6a1.88 1.88 0 0 1-1.79 2.28c-2.89.48-7.43-5.09-9.46-11a170.63 170.63 0 0 1-4.86-20.86 9 9 0 0 1 1.09-4.59 14.09 14.09 0 0 1 1.41-2.34c1.06-2.83 1.73-8.28 2.68-12Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "137.963px 340.269px"
    },
    id: "eluv7zpgojczd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 339.56a6.66 6.66 0 0 0-.85 2.14c-.12 1.31 2.68 5.77 3.78 7.39a10.54 10.54 0 0 1 1.85 7.59c-.33 4.21 1.37 8.34 4 11.92a29 29 0 0 0 14 10c6.87 2.42 9.46-1 9.46-1s2.29-3.27 1-4.7S120 339.56 120 339.56Z",
    style: {
      fill: "#37474f",
      transformOrigin: "136.39px 359.513px"
    },
    id: "eldp24qaegov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33 326.84c-.21 0-.59-.09-1.16.55-.21.24-1.6 3.31-2.72 4.91s-4 4.61-4.46 7.26c1.4 5.22 6.1 9 6.63 13.89s.4 10.55 7.64 16.8 14.91 7.17 17.74 5.7 2.69-4.43-.94-10.23c-3.86-6.14-6.1-19.22-6.1-19.23a44.73 44.73 0 0 1-.51-5.54c-.07-1.78.53-3.66.74-5.44a3.13 3.13 0 0 0-2.26-4 17.76 17.76 0 0 0-3.79-1.45 6 6 0 0 0-4 .32 29.28 29.28 0 0 1-2.53 1.48 3.56 3.56 0 0 1-3.65-.8 3 3 0 0 1-.86-3.42s.23-.8.23-.8Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "136.98px 351.698px"
    },
    id: "elkl4v649f7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33 326.84c-.21 0-.59-.09-1.16.55-.21.24-1.6 3.31-2.72 4.91s-4 4.61-4.46 7.26c1.4 5.22 6.1 9 6.63 13.89s.4 10.55 7.64 16.8 14.91 7.17 17.74 5.7 2.69-4.43-.94-10.23c-3.86-6.14-6.1-19.22-6.1-19.23a44.73 44.73 0 0 1-.51-5.54c-.07-1.78.53-3.66.74-5.44a3.13 3.13 0 0 0-2.26-4 17.76 17.76 0 0 0-3.79-1.45 6 6 0 0 0-4 .32 29.28 29.28 0 0 1-2.53 1.48 3.56 3.56 0 0 1-3.65-.8 3 3 0 0 1-.86-3.42s.23-.8.23-.8Z",
    style: {
      opacity: 0.4,
      transformOrigin: "136.98px 351.698px"
    },
    className: "animable",
    id: "el3ejiwo0bsss"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08 365.31s3.13-5.78 11.07-5.44 10.53 4.49 11.64 6.92c1.33 2.89 2.63 8.07-.71 9.42-3.6 1.45-7.68.79-14-2.69s-8-8.21-8-8.21Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "142.137px 368.393px"
    },
    id: "el7hnvx9n9fiw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.47 341.44a.8.8 0 0 0 .72 0c1.25-.58 7.8-1.68 11.44 2 .51-.37.43-1.09-.15-2.13-4.32-3-10.51-2-12-1.27a.75.75 0 0 0-.35 1 .83.83 0 0 0 .34.4Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "138.512px 341.357px"
    },
    id: "elfeu42jxo23a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.26 348.1a2.41 2.41 0 0 0-.37-2.2c-4.27-2.54-10-1.58-11.47-.91a.75.75 0 0 0-.35 1 .78.78 0 0 0 .36.36.79.79 0 0 0 .72 0c1.22-.49 7.42-1.53 11.11 1.75Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "139.187px 346.171px"
    },
    id: "elsjm8etxu75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08 359a4.55 4.55 0 0 0-.9-2.91c-4.3-2.83-10.35-1.84-11.84-1.15a.74.74 0 0 0-.35 1 .82.82 0 0 0 1.08.38c1.32-.6 8.53-1.79 12.01 2.68Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "141.498px 356.597px"
    },
    id: "elgtuijpz0dlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.38 351.35a.85.85 0 0 0 .73 0c1.24-.57 7.65-1.64 11.31 1.87a2.78 2.78 0 0 0-.57-2.38c-4.27-2.54-10-1.58-11.47-.92A.75.75 0 0 0 134 351a.87.87 0 0 0 .38.35Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "140.192px 351.2px"
    },
    id: "el5peb5hg21h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41 339.32s2.47 19.71 5.78 27.45 5 11.49 9.77 17.44c1 1.29 3.41 3.72 4.26 4.76a2 2 0 0 1-.33 3c-2.29 2-11.69 2.16-16.79-2s-9.56-12.73-12.57-16c-1.13-1.24-2.19-2.5-3.19-3.83s-.64-2.46-.68-3.86c0-.68.15-2.52.15-2.52-.58-3.32-2.33-8.58-3.23-11.83Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "158.165px 366.326px"
    },
    id: "el5dbzalt0weo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38 378.49a7.19 7.19 0 0 0 .14 2.4c.48 1.3 5.12 4.26 6.89 5.31a11 11 0 0 1 5.14 6.35c1.56 4.13 5 7.28 9.07 9.52a30.38 30.38 0 0 0 17.73 3.19c7.58-.79 8.52-5.15 8.52-5.15s.7-4.12-1.11-4.91-46.38-16.71-46.38-16.71Z",
    style: {
      fill: "#37474f",
      transformOrigin: "164.17px 391.99px"
    },
    id: "elylkww8am8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59 362.73c-.21.08-.6.17-.85 1-.1.32 0 3.85-.38 5.87s-1.73 6.14-1 8.86c3.66 4.31 9.79 5.79 12.48 10.18s5.09 9.81 14.73 12.48 17.32.13 19.33-2.52.57-5.4-5.46-9.26c-6.39-4.1-14.35-15.47-14.36-15.48a45.81 45.81 0 0 1-2.95-5c-.86-1.65-1.14-3.69-1.74-5.47a4.21 4.21 0 0 0-1.35-2.24 4.37 4.37 0 0 0-2.56-.53 18.81 18.81 0 0 0-4.24.32 6.37 6.37 0 0 0-3.62 2.08 29.79 29.79 0 0 1-1.74 2.53 3.7 3.7 0 0 1-3.81.87 3.19 3.19 0 0 1-2.34-2.84s-.14-.85-.14-.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "163.949px 381.426px"
    },
    id: "elxncdaz75cf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59 362.73c-.21.08-.6.17-.85 1-.1.32 0 3.85-.38 5.87s-1.73 6.14-1 8.86c3.66 4.31 9.79 5.79 12.48 10.18s5.09 9.81 14.73 12.48 17.32.13 19.33-2.52.57-5.4-5.46-9.26c-6.39-4.1-14.35-15.47-14.36-15.48a45.81 45.81 0 0 1-2.95-5c-.86-1.65-1.14-3.69-1.74-5.47a4.21 4.21 0 0 0-1.35-2.24 4.37 4.37 0 0 0-2.56-.53 18.81 18.81 0 0 0-4.24.32 6.37 6.37 0 0 0-3.62 2.08 29.79 29.79 0 0 1-1.74 2.53 3.7 3.7 0 0 1-3.81.87 3.19 3.19 0 0 1-2.34-2.84s-.14-.85-.14-.85Z",
    style: {
      opacity: 0.4,
      transformOrigin: "163.949px 381.426px"
    },
    className: "animable",
    id: "elh59mcowpfv5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43 398.34s.38-6.86 8-10.09 12-.45 14.11 1.35c2.55 2.14 6.09 6.47 3.54 9.23-2.77 3-6.92 4.19-14.46 3.71s-11.19-4.2-11.19-4.2Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "174.696px 394.704px"
    },
    id: "el7cffneepazf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 374.69a.84.84 0 0 0 .69-.3c.93-1.1 6.63-5.07 11.71-3.24.31-.57-.08-1.23-1.1-1.94-5.41-.9-10.82 2.82-11.94 4.16a.79.79 0 0 0 .14 1.14.85.85 0 0 0 .5.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "158.841px 371.881px"
    },
    id: "eloxwhoq9ki6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11 375.28a2.56 2.56 0 0 0-1.33-1.91c-5.18-.5-10.19 3-11.27 4.26a.79.79 0 0 0 .14 1.14.92.92 0 0 0 .5.18.84.84 0 0 0 .69-.3c.9-1.07 6.31-4.83 11.27-3.37Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "161.719px 376.136px"
    },
    id: "eldeiwhofmhap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63 384.3a4.79 4.79 0 0 0-2.16-2.36c-5.33-.75-10.62 2.89-11.72 4.2a.8.8 0 0 0 .14 1.15.89.89 0 0 0 .49.18.86.86 0 0 0 .7-.3c.98-1.17 7.28-5.52 12.55-2.87Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "168.599px 384.655px"
    },
    id: "el8axyjgai0x6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27 383.21a.84.84 0 0 0 .69-.3c.92-1.09 6.5-5 11.54-3.29a3 3 0 0 0-1.6-2c-5.18-.49-10.2 3-11.27 4.26a.8.8 0 0 0 .14 1.15.89.89 0 0 0 .5.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "164.974px 380.392px"
    },
    id: "elxctkzdgvz2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59 226.07c7.79 6.2 35.13 23.45 46.07 34.41 3.16 3.16 4.08 7.2 2.93 15.89-1.56 11.78-12.44 51.71-12.44 51.71-1.37 2.22-3.45-2.18-3.45-2.18l-42.1-58Z",
    style: {
      fill: "#455a64",
      transformOrigin: "137.833px 277.388px"
    },
    id: "elxll5bz6vusp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72 315.46c-9.92-9-41-62.55-41-62.55l1.4-.24c7.56-3.48 9.94-12.78 9.94-12.78 1 4.2-1.84 10.14-4.88 12.34 2.52 2.36 15.74 14.51 25.66 23 2.49 2.13 5 4.75 5.71 9.4 1.69 11.19 3.5 28.59 3.17 30.83Z",
    style: {
      fill: "#37474f",
      transformOrigin: "132.24px 277.675px"
    },
    id: "el79xfwn5zfee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.59 226.07-54.84 10.07c.48 10.89 0 17.12 2.27 22.13 2.58 5.7 6.36 11.5 20.91 19.39 14 7.6 31.17 15.53 34.6 17.33 2.58 1.36 3.63 6.67 4.55 13.53 1 7.21.86 12.81 7.34 28.1 6.35 15 7.64 18.21 7.64 18.21s10.68 1.54 18-4.44c0 0-7.72-50.79-9.43-59.95-1-5.11-.88-7.78-6.95-13.6-5.21-5-28.58-24.17-28.58-24.17s10.11-12.48 4.49-26.6Z",
    style: {
      fill: "#455a64",
      transformOrigin: "110.405px 290.539px"
    },
    id: "elqi65m4ptfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "94.412px 197.824px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.79 150.87c4.91-.58 11.61-.37 15.55 3.68 4.68 4.82 6.11 8 11.15 22.92 3.33 9.84 9.23 31.81 5.75 35.67s-13 3.22-13 3.22Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "124.546px 183.515px"
    },
    id: "ele5cfiau2tm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28 150.77c5.33-1.26 15-2 20.41 5.31S139.27 191 139.27 191a31.07 31.07 0 0 1-16.72 3.11c-10.02-.77-17.27-43.34-17.27-43.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "122.275px 172.103px"
    },
    id: "eljxfgychv4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 151.75c-6.32.09-18.38 3.31-22.79 4.51-3.77 1.88-2.57 4.49-2.35 9.19.77 16.15 3.34 50.43 3.34 50.43l.07 26.8c21.32 6.84 58.55 1.75 61.5-12.62 0 0-.08-30.27-2.58-53.19C119.3 160 112 150.54 106 150.72Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "91.1375px 198.202px"
    },
    id: "eld80i59l9rhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 205.27.73-21.21c1.2-17-5.06-26.87-7.48-28.31-6.51 1.62-10.46 2.14-13.19 16.83-1 5.43-.65 11.91-.69 22 0 8 .53 16.15 1.34 25.45.58 6.7 3.59 7.78 11.93 7.6 7-.14 28.57-4.29 40.58-7.48 4.86-1.29 12-3.73 15.71-5 2.73-1 13.19-4 12.43-8.16a3.79 3.79 0 0 0-2.22-2.59 10 10 0 0 0-3.46-.72 55.09 55.09 0 0 0-15.53 1c-3.83.81-7.47 1.77-11.34 2.36s-12.09-3.68-15.81-3.27c-7 .78-13 1.5-13 1.5Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "90.3707px 191.699px"
    },
    id: "elfpb0gxzq8dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44 155.13c-6.16 1.09-11.56 3-13.75 7.17s-2.6 6.83-3.35 18.23c-1.05 16.07-.79 23.61-.79 23.61s13 4.23 23.17-1.67l.86-21.36s1.04-17.11-6.14-25.98Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "59.577px 180.369px"
    },
    id: "elikxwjwqx8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.11 214.56s.08-6 9.87-9.29c0 0 6-.72 13-1.5 3.74-.41 12.08 3.88 15.81 3.32s7.51-1.55 11.34-2.36a55.09 55.09 0 0 1 15.53-1 10 10 0 0 1 3.46.72 3.79 3.79 0 0 1 2.22 2.59c.76 4.15-9.7 7.21-12.43 8.16-2 .69-4.89 1.69-7.92 2.67-11.47-3.07-36.61-11.64-40.87-10.53-4.8 1.21-8.78 4.04-10.01 7.22Z",
    style: {
      fill: "#f28f8f",
      opacity: 0.8,
      transformOrigin: "95.7447px 210.718px"
    },
    className: "animable",
    id: "el217xlvy6fxa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49 205.48c9.3 1 41.21 11.4 55.55 10.92 4.36-1.47 4.77-3.72 5.88-9.75s-9.09-12.24-13.37-12.53c-42.35 3-52.48 9.73-52.48 9.73l-.07 1.42s1.8.01 4.49.21Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "103.002px 205.268px"
    },
    id: "el81fblo17zqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      opacity: 0.8,
      transformOrigin: "70.92px 204.28px"
    },
    className: "animable",
    d: "m70.08 203.85-.1 1.42 1.88.06-.3-2.1-1.48.62z",
    id: "el7j8av8i7p4k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 194.22c5 .81 9.73 6.11 9.73 6.11a13.2 13.2 0 0 0-4.64-6.51 41.18 41.18 0 0 1-5.09.4Z",
    style: {
      fill: "#f28f8f",
      opacity: 0.8,
      transformOrigin: "130.165px 197.075px"
    },
    className: "animable",
    id: "el5bv5ac3nrgk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.62 110.9a13.46 13.46 0 1 0 14.6-12.21 13.45 13.45 0 0 0-14.6 12.21Z",
    style: {
      fill: "#263238",
      transformOrigin: "112.027px 112.097px"
    },
    id: "el0ccrvg215l4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.61 121.08s1.54 13.69 2.45 16a5.87 5.87 0 0 0 3.12 3.14l.66-9.47Z",
    style: {
      fill: "#263238",
      transformOrigin: "79.725px 130.65px"
    },
    id: "elcq42lhba7s5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05 102a4.47 4.47 0 0 0-4.24 1.68c-2 2.67-1.36 9.78.8 17.42l5.12 1.08Z",
    style: {
      fill: "#263238",
      transformOrigin: "78.167px 112.062px"
    },
    id: "el0g2p0iax4n4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.24 103.38 72 102.25a3 3 0 0 1 3.5-2.74 3.54 3.54 0 0 1 2.74 3.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "75.1323px 101.423px"
    },
    id: "elq7geuqcxpo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77 101.74 74 96.37a3 3 0 0 1 4.42.7 3.47 3.47 0 0 1-.65 4.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "76.5216px 98.7169px"
    },
    id: "elmtl8d1nnox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28 122.3c-1.1.56-2.39-1.65-3.55-3.16s-4.68-3.18-7.17 1.2A7.49 7.49 0 0 0 76 130.8c3.48 1.4 5-.25 5-.25l-.64 22c8 8.52 26.26 9.81 19.88-.59l.25-5.73s3.9.57 7.45.79c3 .18 6.41-1.62 8.2-6.1 2.16-5.4 3.08-10.07 4-16.89a67.66 67.66 0 0 0 .53-10.51c-.87-15-18.76-20.47-29.15-14.92s-8.24 23.7-8.24 23.7Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "96.1548px 127.916px"
    },
    id: "elfelbcrxp6cs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94 110.27a33.93 33.93 0 0 1-10.45-4.13 1.38 1.38 0 0 0-1-.29 1.35 1.35 0 0 0-.76.85 34.35 34.35 0 0 1-2.37 4.88 7.52 7.52 0 0 1-4.13 3.34 3.15 3.15 0 0 0-1.73.74 3 3 0 0 0-.64 1.72 14 14 0 0 0 .18 2.41c.11 1.1.3 3-.41 3.93a1.74 1.74 0 0 1-2.62.22 10.51 10.51 0 0 1-1.81-2.63 16.13 16.13 0 0 0-1.93-2.68c-.7-.73-.27-2.18-.35-3.16-.16-2-.16-3.93-.13-5.9 0-1.66-.82-5.45-1-7.1-.25-2.38 0-1.52.92-3.14 2.28-7.68 11.09-10.1 17.86-9.08a70.78 70.78 0 0 0 9.08.84 66.37 66.37 0 0 0 11.45-.55 3 3 0 0 1 1.57.07 2 2 0 0 1 .94 2.24 5.92 5.92 0 0 1-1.29 2.27 12.26 12.26 0 0 1 3.66-.85 4.27 4.27 0 0 1 3.41 1.3 5.14 5.14 0 0 1 .74 4.37 13.89 13.89 0 0 1-9.78 10.19 20 20 0 0 1-9.41.14Z",
    style: {
      fill: "#263238",
      transformOrigin: "102.013px 107.231px"
    },
    id: "elmwkyeeuiehq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.44 146.25s-9.15-2.36-12.24-4.45a10.94 10.94 0 0 1-4.08-5 15.68 15.68 0 0 0 2.06 5.7c2.1 3.38 14.16 6.14 14.16 6.14Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "92.28px 142.72px"
    },
    id: "elpmzx9lyvy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52 93.05c-5.27 3.16-11.45 9.34-11.73 23.42a7.42 7.42 0 0 0-3.73 7c.16 4.41 3.4 8.11 7.26 8.27s6.85-3.28 6.7-7.69c-.12-3.3-2.66-7.11-5.41-7.61 0 0-.73-6.09 3-13.94 4.92-10.38 14.82-11 23.89-11.39-3.09-1.56-12.83-2.33-19.98 1.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "90.7697px 110.808px"
    },
    id: "elwl3l5590ee9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52 93.05c-5.27 3.16-11.45 9.34-11.73 23.42a7.42 7.42 0 0 0-3.73 7c.16 4.41 3.4 8.11 7.26 8.27s6.85-3.28 6.7-7.69c-.12-3.3-2.66-7.11-5.41-7.61 0 0-.73-6.09 3-13.94 4.92-10.38 14.82-11 23.89-11.39-3.09-1.56-12.83-2.33-19.98 1.94Z",
    style: {
      opacity: 0.5,
      transformOrigin: "90.7697px 110.808px"
    },
    className: "animable",
    id: "el70tb7y5k6hk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85 124.08c-.17-4.88-3.77-9-8-9.17a6.74 6.74 0 0 0-1.92.21c-.52.13-2.14.73-2.46.84-3 1.05-5.11 4.26-5 8.16.17 4.89 3.77 9 8 9.17a6.56 6.56 0 0 0 2.33-.29l2.26-.8c2.94-1.14 4.94-4.3 4.79-8.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "79.1619px 124.103px"
    },
    id: "elu9muy97iqic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85 124.08c-.17-4.88-3.77-9-8-9.17a6.74 6.74 0 0 0-1.92.21c-.52.13-2.14.73-2.46.84-3 1.05-5.11 4.26-5 8.16.17 4.89 3.77 9 8 9.17a6.56 6.56 0 0 0 2.33-.29l2.26-.8c2.94-1.14 4.94-4.3 4.79-8.12Z",
    style: {
      opacity: 0.3,
      transformOrigin: "79.1619px 124.103px"
    },
    className: "animable",
    id: "elfd9u1l6j7ds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.91 124.77c-.17-4.89-3.76-9-8-9.17s-7.6 3.64-7.43 8.52 3.77 9 8 9.17 7.6-3.64 7.43-8.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "78.195px 124.445px"
    },
    id: "elp4luhvbni8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.91 124.77c-.17-4.89-3.76-9-8-9.17s-7.6 3.64-7.43 8.52 3.77 9 8 9.17 7.6-3.64 7.43-8.52Z",
    style: {
      opacity: 0.1,
      transformOrigin: "78.195px 124.445px"
    },
    className: "animable",
    id: "el3xgrxroauyh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83 124.6a4.32 4.32 0 0 0-3.83-4.33c-2-.08-3.59 1.72-3.51 4a4.32 4.32 0 0 0 3.8 4.33c2.05.11 3.62-1.7 3.54-4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "78.16px 124.436px"
    },
    id: "el967wh0t5upw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.23 122.73a3.14 3.14 0 0 1-6.11-.28 4.61 4.61 0 0 0 6.11.28Z",
    style: {
      fill: "#263238",
      transformOrigin: "99.175px 123.734px"
    },
    id: "elo8vupoam95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78 123.9a3.15 3.15 0 0 1-6.09-.68 4.63 4.63 0 0 0 2.91 1.5 4.69 4.69 0 0 0 3.18-.82Z",
    style: {
      fill: "#263238",
      transformOrigin: "114.735px 124.602px"
    },
    id: "eldcfmsz14eml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.82 115.64-4.43 1.64a2.47 2.47 0 0 1 1.44-3.11 2.32 2.32 0 0 1 2.99 1.47Z",
    style: {
      fill: "#263238",
      transformOrigin: "97.5371px 115.657px"
    },
    id: "el5jp59sqfq5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.2 134.81 4.88 2.2a2.63 2.63 0 0 1-3.5 1.44 2.8 2.8 0 0 1-1.38-3.64Z",
    style: {
      fill: "#b16668",
      transformOrigin: "102.526px 136.74px"
    },
    id: "el3b2rjky84h4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.36 118.31-4.36-1.86a2.29 2.29 0 0 1 3-1.31 2.49 2.49 0 0 1 1.36 3.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "116.26px 116.641px"
    },
    id: "elqgt5gixzhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "109.275px 127.475px"
    },
    id: "elzkfc3pvnq1b",
    className: "animable",
    d: "m106.28 121.66-.1 11.63 6.19-1.68-6.09-9.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.72 132.32a23 23 0 0 1 4.17 3.42 4.31 4.31 0 0 1 0 6l-1.71-.82s1.47-1.88.67-3.29-3.65-3.17-3.65-3.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "121.153px 137.03px"
    },
    id: "el4vn40n0qvh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55 140.47c-1.28-1.09-2.21-.35-3.88 1.86s-1.14 3.09 0 3.9 2.31.23 3.6-1.63c1.46-2.08 1.67-2.96.28-4.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "120.547px 143.28px"
    },
    id: "elokdtm848fp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55 140.47c-1.28-1.09-2.21-.35-3.88 1.86s-1.14 3.09 0 3.9 2.31.23 3.6-1.63c1.46-2.08 1.67-2.96.28-4.13Z",
    style: {
      opacity: 0.1,
      transformOrigin: "120.547px 143.28px"
    },
    className: "animable",
    id: "el3mosy5qghgm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.54 102.42a5.89 5.89 0 0 1-.73-1.9 1.8 1.8 0 0 1 0-.61l6-17.21-7.11 1.23c-.76.14-1.26-.45-1.49-1.77l-.12-.69c-.23-1.31 0-2 .8-2.17l13-2.28c.21 0 .52.31.91 1a6.62 6.62 0 0 1 .74 1.9 2.76 2.76 0 0 1 0 .66l-6 17.11 7.8-1.36a1 1 0 0 1 1 .3 3 3 0 0 1 .54 1.47l.12.68c.23 1.32 0 2-.8 2.18l-13.76 2.4c-.19.08-.51-.25-.9-.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "40.545px 90.1959px"
    },
    id: "elwdr5a1vewlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.82 108.9a5 5 0 0 1-.5-1.6 1.39 1.39 0 0 1 0-.5l5.82-13.74-5.84.62c-.63.07-1-.45-1.13-1.53l-.06-.57c-.11-1.09.15-1.67.78-1.73L65.7 88.7c.17 0 .4.27.69.88a5.29 5.29 0 0 1 .49 1.6 2 2 0 0 1 0 .54l-5.79 13.67 6.45-.69a.76.76 0 0 1 .76.3 2.56 2.56 0 0 1 .36 1.23l.06.57c.12 1.08-.14 1.66-.77 1.73l-11.39 1.22c-.22.02-.46-.26-.74-.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.417px 99.2255px"
    },
    id: "elo9rq2v0h6zq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "61.417px 99.2255px"
    },
    className: "animable",
    id: "eld6v7y0nj6xn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.82 108.9a5 5 0 0 1-.5-1.6 1.39 1.39 0 0 1 0-.5l5.82-13.74-5.84.62c-.63.07-1-.45-1.13-1.53l-.06-.57c-.11-1.09.15-1.67.78-1.73L65.7 88.7c.17 0 .4.27.69.88a5.29 5.29 0 0 1 .49 1.6 2 2 0 0 1 0 .54l-5.79 13.67 6.45-.69a.76.76 0 0 1 .76.3 2.56 2.56 0 0 1 .36 1.23l.06.57c.12 1.08-.14 1.66-.77 1.73l-11.39 1.22c-.22.02-.46-.26-.74-.85Z",
    style: {
      fill: "#fff",
      transformOrigin: "61.417px 99.2255px"
    },
    id: "el595pv4egyqk",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "439.186px 330.021px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-2",
    className: "animable",
    style: {
      transformOrigin: "439.186px 330.021px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-2",
    className: "animable",
    style: {
      transformOrigin: "437.068px 351.763px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.09 380c-9.09-9.37-14.43-47.52-5.56-54.95h45.08c8.86 7.43 3.53 45.56-5.55 54.94l-.25.26-.31.31c-.26.25-.53.5-.82.74l-.22.17c-.22.18-.44.36-.69.53s-.77.53-1.17.76c-7.47 4.36-19.59 4.36-27.06 0a14.13 14.13 0 0 1-1.19-.77c-.22-.16-.43-.32-.63-.49l-.27-.21c-.28-.23-.55-.47-.79-.71l-.37-.36c-.06-.11-.14-.22-.2-.22Z",
    style: {
      fill: "#37474f",
      transformOrigin: "437.068px 355.54px"
    },
    id: "elb1fwel36h5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.69 322c10.29 6 10.29 15.74 0 21.75s-27 6-37.25 0-10.28-15.74 0-21.75 26.97-6 37.25 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "437.074px 332.875px"
    },
    id: "elqvebs6f5scn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.75 324.9c7.55 4.41 7.55 11.56 0 16s-19.81 4.41-27.36 0-7.55-11.56 0-16 19.8-4.41 27.36 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "437.07px 332.9px"
    },
    id: "elb2a9j86e18p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.39 332.48c7.55-4.41 19.8-4.41 27.36 0a12.6 12.6 0 0 1 4.52 4.2 12.5 12.5 0 0 1-4.52 4.19c-7.56 4.41-19.81 4.41-27.36 0a12.5 12.5 0 0 1-4.52-4.19 12.6 12.6 0 0 1 4.52-4.2Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "437.07px 336.675px"
    },
    id: "eli89l658uh0p",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "439.186px 308.126px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.38 313.23a12.33 12.33 0 0 1-1.15-3.29c-.51-2.75.18-5.89 2.4-7.59.88-.67 2-1.17 2.41-2.21a3.51 3.51 0 0 0 0-1.82c-.41-2.34-1.2-4.76-.55-7.05a7.87 7.87 0 0 1 4.37-4.68 23.57 23.57 0 0 1 6.37-1.67 10.21 10.21 0 0 0 3.37-1c1.26-.71 1.65-1.95 2.44-3a21.43 21.43 0 0 1 3.09-3.3c2.29-2.05 5.17-3.74 8.35-3.6 6.63.3 6.44 6 4.53 10.33s-2.42 5.73 1.72 10.24 4.15 10.06-.79 13.17-8.16 3.52-6.2 9.51c1.75 5.35 2.83 9.91-2.11 15.63-3.2 3.69-7.56 6.33-13 6.1a21.79 21.79 0 0 1-6.38-1.49c-1.51-.75-.5-1.92-1-3.4l-3.28-9.56a70.53 70.53 0 0 0-2.6-7.54c-.64-1.33-1.37-2.52-1.99-3.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "452.908px 306.513px"
    },
    id: "elywd0pajv4ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.39 337.47a.49.49 0 0 0 .33-.47c-.28-32.75 17.77-52.31 17.95-52.5a.5.5 0 0 0 0-.7.48.48 0 0 0-.69 0c-.19.2-18.51 20-18.23 53.19a.51.51 0 0 0 .5.49Z",
    style: {
      fill: "#fff",
      transformOrigin: "451.28px 310.567px"
    },
    id: "elzrh6nc8nel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.65 307 .09-.05c5.88-3.7 16.36-6.45 16.47-6.48a.5.5 0 0 0 .35-.6.49.49 0 0 0-.6-.36c-.44.11-10.73 2.83-16.73 6.6a.5.5 0 0 0 .42.89Z",
    style: {
      fill: "#fff",
      transformOrigin: "455.797px 303.256px"
    },
    id: "elpj2e5zcfr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.46 302.52a.5.5 0 0 0 .26-.65 37.25 37.25 0 0 0-5.42-9.11.47.47 0 0 0-.68-.06.5.5 0 0 0-.06.7 37.77 37.77 0 0 1 5.26 8.85.5.5 0 0 0 .64.27Z",
    style: {
      fill: "#fff",
      transformOrigin: "446.602px 297.568px"
    },
    id: "ell504yccc3t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.79 341a27.55 27.55 0 0 1-14.38.53c-8.25-1.78-13.3-9.49-13.3-9.49s8.92-3.57 14.13-3.92a46 46 0 0 0-15.63.33s-4.78-1.77-3.87-9.84c0 0 4.49-3.31 14.84-2 0 0-5.19-3.7-14.28-4.79-.71 0 .26-10.5 1.12-15.18s2.59-4 6.31-3.56 14.71 2.91 16.1 5.61 0 9.57 0 9.57a15.77 15.77 0 0 0 3-9 24.39 24.39 0 0 1 6.35 3.47 14.55 14.55 0 0 1 3.95 4.95c-.51 3.69-2.25 9.31-4.68 12.45a16.77 16.77 0 0 0 6.73-10.05 22.7 22.7 0 0 1 4.34 12.82c.03 8.25-3.63 14.37-10.73 18.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "426.573px 317.503px"
    },
    id: "el9rf6ka423ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.79 341a27.55 27.55 0 0 1-14.38.53c-8.25-1.78-13.3-9.49-13.3-9.49s8.92-3.57 14.13-3.92a46 46 0 0 0-15.63.33s-4.78-1.77-3.87-9.84c0 0 4.49-3.31 14.84-2 0 0-5.19-3.7-14.28-4.79-.71 0 .26-10.5 1.12-15.18s2.59-4 6.31-3.56 14.71 2.91 16.1 5.61 0 9.57 0 9.57a15.77 15.77 0 0 0 3-9 24.39 24.39 0 0 1 6.35 3.47 14.55 14.55 0 0 1 3.95 4.95c-.51 3.69-2.25 9.31-4.68 12.45a16.77 16.77 0 0 0 6.73-10.05 22.7 22.7 0 0 1 4.34 12.82c.03 8.25-3.63 14.37-10.73 18.1Z",
    style: {
      opacity: 0.15,
      transformOrigin: "426.573px 317.503px"
    },
    className: "animable",
    id: "elo6ae7xbxsur"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88 340.29a.49.49 0 0 1-.3-.4c-1.25-15.64-18.74-40.05-26.47-45a.48.48 0 0 1-.14-.65.47.47 0 0 1 .64-.15c7.86 5 25.64 29.8 26.9 45.68a.46.46 0 0 1-.63.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "425.706px 317.156px"
    },
    id: "eliimjpmniewg",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUnavailable);
export default __webpack_public_path__ + "static/media/serviceUnavailable.5c19982b834f4eaa6bb3121da159b1b3.svg";
export { ForwardRef as ReactComponent };